import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Nav,
  Table,
  Tab,
  Form,
  Image,
  Dropdown,
  TabContainer,
  TabContent,
  TabPane,
} from "react-bootstrap";
import Card from "../../../components/Card";
import { Link } from "react-router-dom";
// images
import storeLogo from "../../../assets/images/store/product-detail/store.png";
import ProfileHeader from "../../../components/profile-header";
import profilebg9 from "../../../assets/images/page-img/profile-bg9.jpg";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner";
import Error500 from "../errors/error500";

const StoreDetailOLD = () => {
  const [iappreciated, setIappreciated] = useState([]);
  const [Inominated, setInominated] = useState([]);
  const [apierror, setApiError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getIappreciated = async () => {
    try {
      const userId = localStorage.getItem("userId");
      console.log(userId, "userid here");

      const response = await axios.post(webServiceUrl.Iappreciated, {
        userId: userId,
      });
      console.log(response.data);
      setIappreciated(response.data);
    } catch (error) {
      if (error.message === "Network Error") {
        toast.error("Network Error");
      } else {
        toast.error("Failed to load appreciation data.");
      }
      setApiError(true);
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // I getINominated
  const getINominated = async () => {
    try {
      const userId = localStorage.getItem("userId");
      console.log(userId, "userid here");

      const response = await axios.post(webServiceUrl.Inominated, {
        userId: userId,
      });
      console.log(response.data);
      setInominated(response.data);
    } catch (error) {
      if (error.message === "Network Error") {
        toast.error("Network Error");
      } else {
        toast.error("Failed to load nomination data.");
      }
      console.log(error);
      setApiError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getIappreciated();
    getINominated();
  }, []);

  return (
    <>
      <ProfileHeader img={profilebg9} />
      <div id="content-page" className="content-inner">
        <Container>
          <Row>
            <Col md={12} className="mb-4">
              <div
                className="header-title"
                style={{ textAlign: "left", width: "100%" }}
              >
                <h1 style={{ textAlign: "center", width: "100%" }}>
                  Advantage Club
                </h1>
              </div>
            </Col>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Col lg={12}>
                <Card>
                  <Card.Body className="p-0">
                    <div className="user-tabing p-3">
                      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                        <Nav
                          variant="pills"
                          className="d-flex align-items-center text-center profile-forum-items p-0 m-0 w-75"
                        >
                          <Col sm={3} className="p-0">
                            <Nav.Link
                              eventKey="first"
                              role="button"
                              className="d-flex gap-2 justify-content-center"
                            >
                              <i className="material-symbols-outlined me-1">
                                thumb_up
                              </i>{" "}
                              <span>Appreciate</span>
                            </Nav.Link>
                          </Col>
                          <Col sm={3} className="p-0">
                            <Nav.Link
                              eventKey="second"
                              role="button"
                              className="d-flex gap-2 justify-content-center"
                            >
                              <i className="material-symbols-outlined me-1">
                                emoji_events
                              </i>{" "}
                              <span>Nominate</span>
                            </Nav.Link>
                          </Col>
                          {/* <Col sm={3} className="p-0">
                            <Nav.Link
                              eventKey="third"
                              role="button"
                              className="d-flex gap-2 justify-content-center"
                            >
                              <i className="material-symbols-outlined me-1">
                                card_giftcard
                              </i>{" "}
                              <span>Greetings</span>
                            </Nav.Link>
                          </Col> */}
                          <Col sm={3} className="p-0">
                            <Nav.Link
                              eventKey="fourth"
                              role="button"
                              className="d-flex gap-2 justify-content-center"
                            >
                              <i className="material-symbols-outlined me-1">
                                star
                              </i>{" "}
                              <span>My Badges & Values</span>
                            </Nav.Link>
                          </Col>
                        </Nav>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12}>
                <Tab.Content className="forum-content">
                  <Tab.Pane eventKey="first">
                    <Card>
                      <Card.Body>
                        <div
                          className="header-title"
                          style={{ textAlign: "left", width: "100%" }}
                        >
                          <h1 style={{ textAlign: "center", width: "100%" }}>
                            🏆 I Appreciated
                          </h1>
                        </div>
                        {isLoading ? (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "200px" }}
                          >
                            <Oval
                              visible={true}
                              height="50"
                              width="50"
                              color="#4fa94d"
                              secondaryColor="#4fa94d"
                              radius="12.5"
                              ariaLabel="loading"
                            />
                          </div>
                        ) : apierror ? (
                          // <p className="text-center text-danger mt-4">
                          //   Failed to load data. Please try again later.
                          // </p>
                          <Error500 />
                        ) : iappreciated === 0 ? (
                          <p className="text-center text-muted mt-4">
                            No appreciation records available.
                          </p>
                        ) : (
                          <Table
                            responsive
                            className="forum-table mb-0 rounded mt-4"
                          >
                            <thead className="bg-primary text-white">
                              <tr>
                                <th>Name </th>
                                <th>Message</th>
                              </tr>
                            </thead>
                            <tbody>
                              {iappreciated.map((item) => (
                                <tr key={item.id}>
                                  <td className="col-lg-6">
                                    <div className="d-flex align-items-center">
                                      <div className="media-body ">
                                        <h6 className="mb-0">
                                          <Link to="#">{item.name}</Link>
                                        </h6>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="col-lg-6">
                                    <h6>{item.message}</h6>
                                    <p className="mb-0">
                                      <span
                                        style={{
                                          fontSize: "10px",
                                        }}
                                      >
                                        {" "}
                                        {item.date}
                                      </span>
                                    </p>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}
                      </Card.Body>
                    </Card>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <Card>
                      <Card.Body>
                        <div
                          className="header-title"
                          style={{ textAlign: "left", width: "100%" }}
                        >
                          <h1 style={{ textAlign: "center", width: "100%" }}>
                            🏆 I Nominated
                          </h1>
                        </div>
                        {isLoading ? (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "200px" }}
                          >
                            <Oval
                              visible={true}
                              height="50"
                              width="50"
                              color="#4fa94d"
                              secondaryColor="#4fa94d"
                              radius="12.5"
                              ariaLabel="loading"
                            />
                          </div>
                        ) : apierror ? (
                          <Error500 />
                        ) : Inominated.length === 0 ? (
                          <p> data not available</p>
                        ) : (
                          <Table
                            responsive
                            className="forum-table mb-0 rounded mt-4"
                          >
                            <thead className="bg-primary text-white">
                              <tr>
                                <th>Nomination</th>
                                <th>Citation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Inominated.map((item) => (
                                <tr key={item.id}>
                                  <td className="col-lg-6">
                                    <div className="d-flex align-items-center">
                                      <i
                                        className={`material-symbols-outlined ${item.nomination === "Collaborative"
                                          ? "text-warning"
                                          : item.nomination === "Responsive"
                                            ? "text-primary"
                                            : item.nomination === "Great Job"
                                              ? "text-success"
                                              : item.nomination === "Thank you!"
                                                ? "text-danger"
                                                : item.nomination === "Innovative"
                                                  ? "text-info"
                                                  : ""
                                          }`}
                                        style={{
                                          fontSize: "2rem",
                                        }}
                                      >
                                        stars
                                      </i>

                                      <div className="media-body ms-3">
                                        <h6 className="mb-0">
                                          <Link to="#">{item.nomination}</Link>
                                        </h6>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="col-lg-6">
                                    <h6>{item.citation}</h6>
                                    <p className="mb-0">
                                      <span className="text-dark me-2">
                                        {item.name}
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "10px",
                                        }}
                                      >
                                        {" "}
                                        {item.date}
                                      </span>
                                    </p>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}
                      </Card.Body>
                    </Card>
                  </Tab.Pane>

                  <Tab.Pane eventKey="third">
                    <Card>
                      <Card.Body className="p-4">
                        <h4 className="text-primary text-center my-2">
                          🎁 Send a Greeting to Your Friend!
                        </h4>
                        <Form>
                          <Form.Group className="mb-3" controlId="friendName">
                            <Form.Label>Friend's Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your friend's name"
                            />
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="greetingMessage"
                          >
                            <Form.Label>Your Message</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              placeholder="Write your heartfelt message here..."
                            />
                          </Form.Group>

                          {/* <div className="d-flex justify-content-center gap-2 mb-3">
                            <Button variant="outline-primary">😊</Button>
                            <Button variant="outline-success">🎉</Button>
                            <Button variant="outline-warning">❤️</Button>
                          </div> */}

                          <button
                            type="button"
                            className="btn btn-primary px-4"
                          >
                            Send Greeting
                          </button>
                        </Form>

                        {/* Recent Greetings Section */}
                        <hr className="my-4" />
                        <h5 className="text-center my-4">
                          🗨️ Recent Greetings
                        </h5>
                        <div className="recent-greetings">
                          {[
                            {
                              name: "John Doe",
                              message: "Wishing you a fantastic day! 🎉",
                            },
                            {
                              name: "Jane Smith",
                              message: "Hope you’re doing great! ❤️",
                            },
                            {
                              name: "Alex Brown",
                              message: "You’re awesome! 😊",
                            },
                          ].map((greeting, index) => (
                            <div
                              key={index}
                              className="mb-3 p-3 bg-light rounded shadow-sm"
                            >
                              <strong>{greeting.name}</strong>
                              <p className="mb-0">{greeting.message}</p>
                            </div>
                          ))}
                        </div>
                      </Card.Body>
                    </Card>
                  </Tab.Pane>

                  <Tab.Pane eventKey="fourth">
                    <Card className="shadow-lg border-0 rounded-4">
                      <Card.Body className="d-flex flex-column justify-content-center align-items-center py-4">
                        <h1 className="display-3 fw-bold customText_color">
                          75%
                        </h1>
                        <p className="text-muted fs-5">Advantage Score</p>
                        <i
                          className="material-symbols-outlined text-warning"
                          style={{ fontSize: "3rem" }}
                        >
                          stars
                        </i>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body>
                        <Row className="mt-5 pt-4">
                          <Col lg={12}>
                            <div className="product-detail-tabs">
                              <TabContainer defaultActiveKey={"description"}>
                                <Nav
                                  as="ul"
                                  className="nav nav-tabs justify-content-center gap-4 mb-3 gap-lg-5 border-bottom"
                                  id="product-tab"
                                  role="tablist"
                                >
                                  <li className="nav-item" role="presentation">
                                    <Nav.Link
                                      to="#"
                                      className="nav-link bg-transparent px-0 py-2 fs-5 rounded-0"
                                      data-bs-toggle="tab"
                                      data-bs-target="#description"
                                      eventKey={"description"}
                                      role="tab"
                                      aria-selected="true"
                                    >
                                      Nomination Received
                                    </Nav.Link>
                                  </li>
                                  <li className="nav-item" role="presentation">
                                    <Nav.Link
                                      to="#"
                                      className="nav-link bg-transparent px-0 py-2 fs-5 rounded-0"
                                      data-bs-toggle="tab"
                                      data-bs-target="#additional-information"
                                      role="tab"
                                      aria-selected="false"
                                      eventKey={"additional-information"}
                                    >
                                      Appreciation received
                                    </Nav.Link>
                                  </li>
                                </Nav>
                                <TabContent id="product-tab-content">
                                  {/* Nomination Received */}
                                  <TabPane
                                    className="tab-pane fade show"
                                    id="description"
                                    eventKey={"description"}
                                    role="tabpanel"
                                  >
                                    <Card>
                                      <Card.Body>
                                        {isLoading ? (
                                          <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ height: "200px" }}
                                          >
                                            <Oval
                                              visible={true}
                                              height="50"
                                              width="50"
                                              color="#4fa94d"
                                              secondaryColor="#4fa94d"
                                              radius="12.5"
                                              ariaLabel="mutating-dots-loading"
                                              wrapperStyle={{}}
                                              wrapperClass=""
                                            />
                                          </div>
                                        ) : apierror ? (
                                          <p>
                                            {" "}
                                            <Error500 />
                                          </p>
                                        ) : Inominated.length === 0 ? (
                                          <p>
                                            No Nomination records available.
                                          </p>
                                        ) : (
                                          <Table
                                            responsive
                                            className="forum-table mb-0 rounded mt-4"
                                          >
                                            <thead className="bg-primary text-white">
                                              <tr>
                                                <th>Nomination</th>
                                                <th>Citation</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {Inominated.map((item) => (
                                                <tr key={item.id}>
                                                  <td className="col-lg-6">
                                                    <div className="d-flex align-items-center">
                                                      <i
                                                        className={`material-symbols-outlined ${item.nomination ===
                                                          "Collaborative"
                                                          ? "text-warning"
                                                          : item.nomination ===
                                                            "Responsive"
                                                            ? "text-primary"
                                                            : item.nomination ===
                                                              "Great Job"
                                                              ? "text-success"
                                                              : item.nomination ===
                                                                "Thank you!"
                                                                ? "text-danger"
                                                                : item.nomination ===
                                                                  "Innovative"
                                                                  ? "text-info"
                                                                  : ""
                                                          }`}
                                                        style={{
                                                          fontSize: "2rem",
                                                        }}
                                                      >
                                                        stars
                                                      </i>

                                                      <div className="media-body ms-3">
                                                        <h6 className="mb-0">
                                                          <Link to="#">
                                                            {item.nomination}
                                                          </Link>
                                                        </h6>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td className="col-lg-6">
                                                    <h6>{item.citation}</h6>
                                                    <p className="mb-0">
                                                      <span className="text-dark me-2">
                                                        {item.name}
                                                      </span>
                                                      <span
                                                        style={{
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        {" "}
                                                        {item.date}
                                                      </span>
                                                    </p>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </Table>
                                        )}
                                      </Card.Body>
                                    </Card>
                                  </TabPane>

                                  {/*  Appreciation received */}
                                  <TabPane
                                    className="tab-pane fade"
                                    id="additional-information"
                                    role="tabpanel"
                                    eventKey={"additional-information"}
                                  >
                                    {isLoading ? (
                                      <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ height: "200px" }}
                                      >
                                        <Oval
                                          visible={true}
                                          height="50"
                                          width="50"
                                          color="#4fa94d"
                                          secondaryColor="#4fa94d"
                                          radius="12.5"
                                          ariaLabel="mutating-dots-loading"
                                          wrapperStyle={{}}
                                          wrapperClass=""
                                        />
                                      </div>
                                    ) : apierror ? (
                                      <Error500 />
                                    ) : iappreciated.length === 0 ? (
                                      <p>data not available</p>
                                    ) : (
                                      <Table
                                        responsive
                                        className="forum-table mb-0 rounded mt-4"
                                      >
                                        <thead className="bg-primary text-white">
                                          <tr>
                                            <th>Name </th>
                                            <th>Message</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {iappreciated.map((item) => (
                                            <tr key={item.id}>
                                              <td className="col-lg-6">
                                                <div className="d-flex align-items-center">
                                                  <div className="media-body ">
                                                    <h6 className="mb-0">
                                                      <Link to="#">
                                                        {item.name}
                                                      </Link>
                                                    </h6>
                                                  </div>
                                                </div>
                                              </td>
                                              <td className="col-lg-6">
                                                <h6>{item.message}</h6>
                                                <p className="mb-0">
                                                  <span
                                                    style={{
                                                      fontSize: "10px",
                                                    }}
                                                  >
                                                    {" "}
                                                    {item.date}
                                                  </span>
                                                </p>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </Table>
                                    )}
                                  </TabPane>

                                  <TabPane
                                    className="tab-pane fade"
                                    id="reviews"
                                    role="tabpanel"
                                    eventKey={"reviews"}
                                  >
                                    <div>
                                      <Container>
                                        <Row className="">
                                          <Col lg="6" className="mt-4">
                                            <Card className="shadow h-100">
                                              <Card.Header className="d-flex justify-content-between">
                                                <div className="header-title">
                                                  <h4 className="card-title">
                                                    Day 1: Introduction to Java
                                                    & Basics (5 Hours)
                                                  </h4>
                                                </div>
                                              </Card.Header>
                                              <Card.Body className="pt-0">
                                                <ul className="iq-timeline ms-1">
                                                  <li>
                                                    <div className="timeline-dots"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Introduction to
                                                        Programming & Java (1
                                                        Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        24 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>Why learn Java?</p>
                                                      <p>
                                                        History & evolution of
                                                        Java
                                                      </p>
                                                      <p>
                                                        Applications of Java
                                                        (Web, Mobile, IoT, AI)
                                                      </p>
                                                      <p>
                                                        Setting up Java (JDK &
                                                        IDEs like
                                                        Eclipse/IntelliJ/VS
                                                        Code)
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-success"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Basic Syntax & First
                                                        Java Program (1 Hour)
                                                      </h6>
                                                      <small>
                                                        23 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        {" "}
                                                        Structure of a Java
                                                        program
                                                      </p>
                                                      <p>
                                                        Writing & running
                                                        "Hello, World!"
                                                      </p>
                                                      <p>
                                                        Comments & coding
                                                        standards
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-danger"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Variables, Data Types &
                                                        Operators (1 Hour)
                                                      </h6>
                                                      <small>
                                                        20 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Primitive &
                                                        Non-primitive data types
                                                      </p>
                                                      <p>
                                                        Declaring & initializing
                                                        variables
                                                      </p>
                                                      <p>
                                                        Arithmetic, relational,
                                                        logical operators
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-primary"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        User Input & Output (1
                                                        Hour)
                                                      </h6>
                                                      <small>
                                                        19 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Scanner class for user
                                                        input
                                                      </p>
                                                      <p>
                                                        System.out.print() and
                                                        System.out.println()
                                                      </p>
                                                      <p>
                                                        Simple console-based
                                                        programs
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-info"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Hands-on Coding & Q&A (1
                                                        Hour)
                                                      </h6>
                                                      <small>
                                                        15 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block w-100">
                                                      <p>
                                                        o Mini exercises
                                                        (printing user details,
                                                        calculating area of a
                                                        circle)
                                                      </p>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                          <Col lg="6" className="mt-4">
                                            <Card className="shadow h-100">
                                              <Card.Header className="d-flex justify-content-between">
                                                <div className="header-title">
                                                  <h4 className="card-title">
                                                    Day 2: Control Flow & Loops
                                                    (5 Hours)
                                                  </h4>
                                                </div>
                                              </Card.Header>
                                              <Card.Body className="pt-0">
                                                <ul className="iq-timeline ms-1">
                                                  <li>
                                                    <div className="timeline-dots"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Decision Making in Java
                                                        (1 Hour)
                                                      </h6>
                                                      <small>
                                                        25 November 2019
                                                      </small>
                                                    </div>
                                                    {/* <div className="d-flex justify-content-end">
                                            <small>25 November 2019</small>
                                          </div> */}
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        if, if-else, if-else-if,
                                                        switch-case
                                                      </p>
                                                      <p>
                                                        Practical examples
                                                        (grading system, traffic
                                                        light program)
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-success"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Loops in Java (1 Hour)
                                                      </h6>
                                                      <small>
                                                        24 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        for, while, do-while
                                                        loops
                                                      </p>
                                                      <p>
                                                        Loop control statements
                                                        (break, continue)
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-danger"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Nested Loops & Patterns
                                                        (1 Hour)
                                                      </h6>
                                                      <small>
                                                        23 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Printing patterns
                                                        (stars, numbers)
                                                      </p>
                                                      <p>
                                                        Fibonacci series,
                                                        factorial calculation
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-primary"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Hands-on Coding (1 Hour)
                                                      </h6>
                                                      <small>
                                                        22 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Implementing a simple
                                                        number guessing game
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-info"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Q&A & Debugging Practice
                                                        (1 Hour)
                                                      </h6>
                                                      <small>
                                                        21 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Identifying errors in
                                                        code
                                                      </p>
                                                      <p>
                                                        Fixing logical mistakes
                                                      </p>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                          <Col lg="6" className="mt-4">
                                            {/* Day 3: Functions & Arrays */}
                                            <Card className="shadow h-100">
                                              <Card.Header className="d-flex justify-content-between">
                                                <div className="header-title">
                                                  <h4 className="card-title">
                                                    Day 3: Functions & Arrays (5
                                                    Hours)
                                                  </h4>
                                                </div>
                                              </Card.Header>
                                              <Card.Body className="pt-0">
                                                <ul className="iq-timeline ms-1">
                                                  <li>
                                                    <div className="timeline-dots"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Methods in Java (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        25 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Defining & calling
                                                        methods
                                                      </p>
                                                      <p>
                                                        Method parameters &
                                                        return types
                                                      </p>
                                                      <p>
                                                        Static vs non-static
                                                        methods
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-success"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Arrays (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        24 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Single-dimensional &
                                                        multi-dimensional arrays
                                                      </p>
                                                      <p>
                                                        Array traversal &
                                                        manipulation
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-danger"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Strings & String Methods
                                                        (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        23 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        String concatenation,
                                                        length, comparison
                                                      </p>
                                                      <p>
                                                        StringBuilder for
                                                        efficient manipulation
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-primary"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Hands-on Coding (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Creating a mini contact
                                                        book using arrays &
                                                        methods
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-info"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Q&A & Debugging Practice
                                                        (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Common errors &
                                                        debugging techniques
                                                      </p>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </Card.Body>
                                            </Card>
                                          </Col>

                                          <Col lg="6" className="mt-4">
                                            {/* Day 4: Object-Oriented Programming (OOP) */}
                                            <Card className="shadow h-100">
                                              <Card.Header className="d-flex justify-content-between">
                                                <div className="header-title">
                                                  <h4 className="card-title">
                                                    Day 4: Object-Oriented
                                                    Programming (OOP) (5 Hours)
                                                  </h4>
                                                </div>
                                              </Card.Header>
                                              <Card.Body className="pt-0">
                                                <ul className="iq-timeline ms-1">
                                                  <li>
                                                    <div className="timeline-dots"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Classes & Objects (1
                                                        Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        26 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Creating & using objects
                                                      </p>
                                                      <p>
                                                        Constructors & this
                                                        keyword
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-success"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Encapsulation &
                                                        Inheritance (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        25 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Private variables &
                                                        getter/setter methods
                                                      </p>
                                                      <p>
                                                        Inheriting properties
                                                        from parent class
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-danger"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Polymorphism & Method
                                                        Overloading (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        24 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Compile-time vs runtime
                                                        polymorphism
                                                      </p>
                                                      <p>Method overloading</p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-primary"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Hands-on Coding (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Creating a student
                                                        management system with
                                                        OOP
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-info"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Q&A & Debugging (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Exploring real-world OOP
                                                        examples
                                                      </p>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </Card.Body>
                                            </Card>
                                          </Col>

                                          <Col lg="6" className="mt-4">
                                            {/* Day 5: Mini Project & Final Assessment */}
                                            <Card className="shadow h-100">
                                              <Card.Header className="d-flex justify-content-between">
                                                <div className="header-title">
                                                  <h4 className="card-title">
                                                    Day 5: Mini Project & Final
                                                    Assessment (5 Hours)
                                                  </h4>
                                                </div>
                                              </Card.Header>
                                              <Card.Body className="pt-0">
                                                <ul className="iq-timeline ms-1">
                                                  <li>
                                                    <div className="timeline-dots"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Introduction to Java
                                                        Mini Project (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        27 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Explaining the project:
                                                        Student Grade Management
                                                        System
                                                      </p>
                                                      <p>
                                                        Requirements & planning
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-success"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Project Implementation
                                                        (2 Hours)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        26 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Creating classes for
                                                        students
                                                      </p>
                                                      <p>
                                                        Adding features (marks
                                                        entry, grading,
                                                        displaying results)
                                                      </p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-danger"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Testing & Debugging (1
                                                        Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-end">
                                                      <small>
                                                        25 November 2019
                                                      </small>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>Running test cases</p>
                                                      <p>Fixing issues</p>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="timeline-dots border-primary"></div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <h6 className="mb-1">
                                                        Final Presentation &
                                                        Assessment (1 Hour)
                                                      </h6>
                                                    </div>
                                                    <div className="d-inline-block timeline-icon w-100">
                                                      <p>
                                                        Students showcase their
                                                        projects
                                                      </p>
                                                      <p>
                                                        Q&A session & feedback
                                                      </p>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                        </Row>
                                      </Container>
                                    </div>
                                  </TabPane>
                                  <TabPane
                                    eventKey={"storedetail"}
                                    className="tab-pane fade"
                                    id="storedetail"
                                    role="tabpanel"
                                  >
                                    <div className="d-flex align-items-center gap-3">
                                      <img
                                        src={storeLogo}
                                        alt=""
                                        loading="lazy"
                                      />
                                      <div>
                                        <h5 className="text capitalize fw-semibold">
                                          voltt scale store
                                        </h5>
                                        <div className="d-flex align-items-center w-100 mt-2 flex-wrap">
                                          <svg
                                            className="icon-24"
                                            width="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
                                              fill="#FFD329"
                                            ></path>
                                          </svg>
                                          <svg
                                            className="icon-24"
                                            width="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
                                              fill="#FFD329"
                                            ></path>
                                          </svg>
                                          <svg
                                            className="icon-24"
                                            width="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
                                              fill="#FFD329"
                                            ></path>
                                          </svg>
                                          <svg
                                            className="icon-24"
                                            width="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
                                              fill="#FFD329"
                                            ></path>
                                          </svg>
                                          <svg
                                            className="icon-24"
                                            width="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
                                              fill="#6c757d"
                                            ></path>
                                          </svg>
                                          <span className="ms-1 font-size-14 fw-semibold text-capitalize">
                                            (4 customer review)
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="table-responsive store-detail-table">
                                      <table className="mt-5 pt-2">
                                        <tbody>
                                          <tr>
                                            <th className="w-25">
                                              <h6 className="text-capitalize fw-semibold">
                                                address:
                                              </h6>
                                            </th>
                                            <td className="w-75">
                                              492 Devon StreetMissoula, MT
                                              59801, united states
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="w-25">
                                              <h6 className="text-capitalize fw-semibold">
                                                time:
                                              </h6>
                                            </th>
                                            <td className="w-75">
                                              <h6 className="text-capitalize fw-normal mb-2">
                                                mon to fri:
                                                <span className="text-body ms-2">
                                                  08:00 AM - 16:00 PM
                                                </span>
                                              </h6>
                                              <h6 className="text-capitalize fw-normal">
                                                Weekends:
                                                <span className="text-body ms-2">
                                                  Closed
                                                </span>
                                              </h6>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="w-25">
                                              <h6 className="text-capitalize fw-semibold">
                                                number:
                                              </h6>
                                            </th>
                                            <td className="w-75 text-primary">
                                              (+16) 813 021 021
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="w-25">
                                              <h6 className="text-capitalize fw-semibold">
                                                Follow Us:
                                              </h6>
                                            </th>
                                            <td className="w-75">
                                              <ul className="list-inline d-flex align-items-center gap-2 mb-0">
                                                <li>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="32"
                                                    height="32"
                                                    viewBox="0 0 32 32"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M14 27.8667C8.33333 26.8667 4 21.9333 4 16C4 9.4 9.4 4 16 4C22.6 4 28 9.4 28 16C28 21.9333 23.6667 26.8667 18 27.8667L17.3333 27.3333H14.6667L14 27.8667Z"
                                                      fill="url(#paint0_linear_963_723)"
                                                    />
                                                    <path
                                                      d="M20.6667 19.3334L21.2 16H18V13.6667C18 12.7334 18.3333 12 19.8 12H21.3333V8.93335C20.4667 8.80002 19.5333 8.66669 18.6667 8.66669C15.9333 8.66669 14 10.3334 14 13.3334V16H11V19.3334H14V27.8C14.6667 27.9334 15.3333 28 16 28C16.6667 28 17.3333 27.9334 18 27.8V19.3334H20.6667Z"
                                                      fill="white"
                                                    />
                                                    <defs>
                                                      <linearGradient
                                                        id="paint0_linear_963_723"
                                                        x1="16"
                                                        y1="27.1693"
                                                        x2="16"
                                                        y2="4"
                                                        gradientUnits="userSpaceOnUse"
                                                      >
                                                        <stop stopColor="#0062E0" />
                                                        <stop
                                                          offset="1"
                                                          stopColor="#19AFFF"
                                                        />
                                                      </linearGradient>
                                                    </defs>
                                                  </svg>
                                                </li>
                                                <li>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="32"
                                                    height="32"
                                                    viewBox="0 0 32 32"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M16.0003 4.36365C12.8401 4.36365 12.4435 4.37747 11.2023 4.43395C9.9636 4.49068 9.11805 4.6868 8.37819 4.97456C7.61288 5.27177 6.96369 5.66934 6.31692 6.31637C5.66967 6.96316 5.2721 7.61237 4.97393 8.37747C4.68545 9.11759 4.4891 9.96341 4.43334 11.2017C4.37783 12.4429 4.36328 12.8398 4.36328 16C4.36328 19.1603 4.37734 19.5556 4.43358 20.7969C4.49055 22.0356 4.68667 22.8812 4.97417 23.6211C5.27162 24.3864 5.66918 25.0356 6.31619 25.6824C6.96272 26.3297 7.61191 26.7283 8.37674 27.0255C9.11708 27.3132 9.96287 27.5093 11.2014 27.5661C12.4426 27.6226 12.8389 27.6364 15.9988 27.6364C19.1592 27.6364 19.5546 27.6226 20.7958 27.5661C22.0345 27.5093 22.881 27.3132 23.6214 27.0255C24.3864 26.7283 25.0347 26.3297 25.6812 25.6824C26.3284 25.0356 26.726 24.3864 27.0242 23.6213C27.3102 22.8812 27.5066 22.0354 27.5648 20.7971C27.6205 19.5559 27.6351 19.1603 27.6351 16C27.6351 12.8398 27.6205 12.4432 27.5648 11.202C27.5066 9.96316 27.3102 9.11759 27.0242 8.37771C26.726 7.61237 26.3284 6.96316 25.6812 6.31637C25.0339 5.6691 24.3867 5.27153 23.6206 4.97456C22.8788 4.6868 22.0328 4.49068 20.7941 4.43395C19.5529 4.37747 19.1577 4.36365 15.9966 4.36365H16.0003ZM14.9564 6.46062C15.2662 6.46013 15.6119 6.46062 16.0003 6.46062C19.1071 6.46062 19.4753 6.47177 20.7022 6.52753C21.8367 6.57941 22.4524 6.76898 22.8626 6.92825C23.4056 7.13916 23.7928 7.39128 24.1998 7.79856C24.607 8.20583 24.8591 8.59371 25.0705 9.13674C25.2298 9.54643 25.4196 10.1622 25.4712 11.2967C25.527 12.5234 25.5391 12.8919 25.5391 15.9973C25.5391 19.1028 25.527 19.4713 25.4712 20.698C25.4194 21.8325 25.2298 22.4483 25.0705 22.858C24.8596 23.401 24.607 23.7876 24.1998 24.1947C23.7925 24.6019 23.4059 24.8541 22.8626 25.065C22.4529 25.225 21.8367 25.4141 20.7022 25.466C19.4756 25.5217 19.1071 25.5338 16.0003 25.5338C12.8932 25.5338 12.525 25.5217 11.2983 25.466C10.1638 25.4136 9.54809 25.224 9.13768 25.0647C8.59467 24.8538 8.2068 24.6017 7.79954 24.1944C7.39228 23.7872 7.14017 23.4003 6.92878 22.857C6.76951 22.4473 6.5797 21.8315 6.52806 20.697C6.47231 19.4703 6.46116 19.1018 6.46116 15.9944C6.46116 12.887 6.47231 12.5205 6.52806 11.2938C6.57994 10.1593 6.76951 9.54353 6.92878 9.13334C7.13968 8.59031 7.39228 8.20244 7.79954 7.79516C8.2068 7.38789 8.59467 7.13577 9.13768 6.92437C9.54785 6.76437 10.1638 6.57528 11.2983 6.52316C12.3718 6.47468 12.7878 6.46013 14.9564 6.45771V6.46062ZM22.2115 8.39274C21.4406 8.39274 20.8151 9.01747 20.8151 9.78862C20.8151 10.5595 21.4406 11.185 22.2115 11.185C22.9824 11.185 23.6078 10.5595 23.6078 9.78862C23.6078 9.01771 22.9824 8.39225 22.2115 8.39225V8.39274ZM16.0003 10.0243C12.7002 10.0243 10.0247 12.6999 10.0247 16C10.0247 19.3001 12.7002 21.9746 16.0003 21.9746C19.3003 21.9746 21.9749 19.3001 21.9749 16C21.9749 12.6999 19.3 10.0243 16 10.0243H16.0003ZM16.0003 12.1212C18.1423 12.1212 19.8789 13.8577 19.8789 16C19.8789 18.1421 18.1423 19.8788 16.0003 19.8788C13.858 19.8788 12.1216 18.1421 12.1216 16C12.1216 13.8577 13.858 12.1212 16.0003 12.1212Z"
                                                      fill="url(#paint0_radial_963_724)"
                                                    />
                                                    <path
                                                      d="M16.0003 4.36365C12.8401 4.36365 12.4435 4.37747 11.2023 4.43395C9.9636 4.49068 9.11805 4.6868 8.37819 4.97456C7.61288 5.27177 6.96369 5.66934 6.31692 6.31637C5.66967 6.96316 5.2721 7.61237 4.97393 8.37747C4.68545 9.11759 4.4891 9.96341 4.43334 11.2017C4.37783 12.4429 4.36328 12.8398 4.36328 16C4.36328 19.1603 4.37734 19.5556 4.43358 20.7969C4.49055 22.0356 4.68667 22.8812 4.97417 23.6211C5.27162 24.3864 5.66918 25.0356 6.31619 25.6824C6.96272 26.3297 7.61191 26.7283 8.37674 27.0255C9.11708 27.3132 9.96287 27.5093 11.2014 27.5661C12.4426 27.6226 12.8389 27.6364 15.9988 27.6364C19.1592 27.6364 19.5546 27.6226 20.7958 27.5661C22.0345 27.5093 22.881 27.3132 23.6214 27.0255C24.3864 26.7283 25.0347 26.3297 25.6812 25.6824C26.3284 25.0356 26.726 24.3864 27.0242 23.6213C27.3102 22.8812 27.5066 22.0354 27.5648 20.7971C27.6205 19.5559 27.6351 19.1603 27.6351 16C27.6351 12.8398 27.6205 12.4432 27.5648 11.202C27.5066 9.96316 27.3102 9.11759 27.0242 8.37771C26.726 7.61237 26.3284 6.96316 25.6812 6.31637C25.0339 5.6691 24.3867 5.27153 23.6206 4.97456C22.8788 4.6868 22.0328 4.49068 20.7941 4.43395C19.5529 4.37747 19.1577 4.36365 15.9966 4.36365H16.0003ZM14.9564 6.46062C15.2662 6.46013 15.6119 6.46062 16.0003 6.46062C19.1071 6.46062 19.4753 6.47177 20.7022 6.52753C21.8367 6.57941 22.4524 6.76898 22.8626 6.92825C23.4056 7.13916 23.7928 7.39128 24.1998 7.79856C24.607 8.20583 24.8591 8.59371 25.0705 9.13674C25.2298 9.54643 25.4196 10.1622 25.4712 11.2967C25.527 12.5234 25.5391 12.8919 25.5391 15.9973C25.5391 19.1028 25.527 19.4713 25.4712 20.698C25.4194 21.8325 25.2298 22.4483 25.0705 22.858C24.8596 23.401 24.607 23.7876 24.1998 24.1947C23.7925 24.6019 23.4059 24.8541 22.8626 25.065C22.4529 25.225 21.8367 25.4141 20.7022 25.466C19.4756 25.5217 19.1071 25.5338 16.0003 25.5338C12.8932 25.5338 12.525 25.5217 11.2983 25.466C10.1638 25.4136 9.54809 25.224 9.13768 25.0647C8.59467 24.8538 8.2068 24.6017 7.79954 24.1944C7.39228 23.7872 7.14017 23.4003 6.92878 22.857C6.76951 22.4473 6.5797 21.8315 6.52806 20.697C6.47231 19.4703 6.46116 19.1018 6.46116 15.9944C6.46116 12.887 6.47231 12.5205 6.52806 11.2938C6.57994 10.1593 6.76951 9.54353 6.92878 9.13334C7.13968 8.59031 7.39228 8.20244 7.79954 7.79516C8.2068 7.38789 8.59467 7.13577 9.13768 6.92437C9.54785 6.76437 10.1638 6.57528 11.2983 6.52316C12.3718 6.47468 12.7878 6.46013 14.9564 6.45771V6.46062ZM22.2115 8.39274C21.4406 8.39274 20.8151 9.01747 20.8151 9.78862C20.8151 10.5595 21.4406 11.185 22.2115 11.185C22.9824 11.185 23.6078 10.5595 23.6078 9.78862C23.6078 9.01771 22.9824 8.39225 22.2115 8.39225V8.39274ZM16.0003 10.0243C12.7002 10.0243 10.0247 12.6999 10.0247 16C10.0247 19.3001 12.7002 21.9746 16.0003 21.9746C19.3003 21.9746 21.9749 19.3001 21.9749 16C21.9749 12.6999 19.3 10.0243 16 10.0243H16.0003ZM16.0003 12.1212C18.1423 12.1212 19.8789 13.8577 19.8789 16C19.8789 18.1421 18.1423 19.8788 16.0003 19.8788C13.858 19.8788 12.1216 18.1421 12.1216 16C12.1216 13.8577 13.858 12.1212 16.0003 12.1212Z"
                                                      fill="url(#paint1_radial_963_724)"
                                                    />
                                                    <defs>
                                                      <radialGradient
                                                        id="paint0_radial_963_724"
                                                        cx="0"
                                                        cy="0"
                                                        r="1"
                                                        gradientUnits="userSpaceOnUse"
                                                        gradientTransform="translate(10.5449 29.4289) rotate(-90) scale(23.065 21.4514)"
                                                      >
                                                        <stop stopColor="#FFDD55" />
                                                        <stop
                                                          offset="0.1"
                                                          stopColor="#FFDD55"
                                                        />
                                                        <stop
                                                          offset="0.5"
                                                          stopColor="#FF543E"
                                                        />
                                                        <stop
                                                          offset="1"
                                                          stopColor="#C837AB"
                                                        />
                                                      </radialGradient>
                                                      <radialGradient
                                                        id="paint1_radial_963_724"
                                                        cx="0"
                                                        cy="0"
                                                        r="1"
                                                        gradientUnits="userSpaceOnUse"
                                                        gradientTransform="translate(0.465135 6.04018) rotate(78.6811) scale(10.3101 42.4972)"
                                                      >
                                                        <stop stopColor="#3771C8" />
                                                        <stop
                                                          offset="0.128"
                                                          stopColor="#3771C8"
                                                        />
                                                        <stop
                                                          offset="1"
                                                          stopColor="#6600FF"
                                                          stopOpacity="0"
                                                        />
                                                      </radialGradient>
                                                    </defs>
                                                  </svg>
                                                </li>
                                                <li>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="32"
                                                    height="32"
                                                    viewBox="0 0 32 32"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M4.66699 6.27557C4.66699 5.38701 5.38732 4.66669 6.27588 4.66669H25.7248C26.6133 4.66669 27.3337 5.38701 27.3337 6.27557V25.7244C27.3337 26.613 26.6133 27.3333 25.7248 27.3333H6.27588C5.38732 27.3333 4.66699 26.613 4.66699 25.7244V6.27557Z"
                                                      fill="#0A66C2"
                                                    />
                                                    <path
                                                      d="M9.75441 11.7059C10.8404 11.7059 11.7207 10.8255 11.7207 9.73952C11.7207 8.65355 10.8404 7.77319 9.75441 7.77319C8.66844 7.77319 7.78809 8.65355 7.78809 9.73952C7.78809 10.8255 8.66844 11.7059 9.75441 11.7059Z"
                                                      fill="white"
                                                    />
                                                    <path
                                                      d="M13.5216 13.159H16.7804V14.6519C16.7804 14.6519 17.6647 12.8833 20.0709 12.8833C22.2173 12.8833 23.9953 13.9406 23.9953 17.1635V23.9597H20.6182V17.987C20.6182 16.0858 19.6032 15.8767 18.8297 15.8767C17.2246 15.8767 16.9498 17.2613 16.9498 18.235V23.9597H13.5216V13.159Z"
                                                      fill="white"
                                                    />
                                                    <path
                                                      d="M8.04032 13.159H11.4685V23.9597H8.04032V13.159Z"
                                                      fill="white"
                                                    />
                                                  </svg>
                                                </li>
                                                <li>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="32"
                                                    height="32"
                                                    viewBox="0 0 32 32"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M17.6372 4.112C14.7664 3.71708 11.8497 4.37422 9.42555 5.96205C7.00144 7.54988 5.23369 9.96118 4.44872 12.7507C3.66374 15.5402 3.91457 18.5195 5.15488 21.1385C6.39519 23.7575 8.54121 25.8393 11.1967 26.9995C11.1249 26.0779 11.1908 25.1506 11.3922 24.2484C11.6142 23.2417 12.9472 17.6938 12.9472 17.6938C12.6818 17.0988 12.5491 16.4532 12.5585 15.8017C12.5585 14.02 13.5867 12.6906 14.8657 12.6906C15.0955 12.6873 15.3233 12.7334 15.5336 12.826C15.7439 12.9185 15.9319 13.0553 16.0846 13.227C16.2374 13.3986 16.3514 13.6012 16.4189 13.8208C16.4864 14.0405 16.5058 14.2721 16.4758 14.4999C16.4758 15.5798 15.7823 17.2139 15.42 18.7473C15.3484 19.0285 15.3438 19.3226 15.4067 19.6059C15.4696 19.8891 15.5982 20.1537 15.7821 20.3782C15.9659 20.6027 16.2 20.7809 16.4653 20.8983C16.7307 21.0158 17.0199 21.0693 17.3097 21.0545C19.5869 21.0545 21.1131 18.1378 21.1131 14.6943C21.1131 12.0547 19.365 10.0774 16.1423 10.0774C15.3713 10.0475 14.6022 10.1745 13.8818 10.4509C13.1613 10.7272 12.5046 11.1471 11.9514 11.685C11.3982 12.223 10.9601 12.8677 10.6637 13.5801C10.3674 14.2925 10.2188 15.0578 10.2272 15.8293C10.1929 16.6852 10.469 17.5246 11.0047 18.1929C11.1048 18.2677 11.1779 18.3729 11.213 18.4928C11.248 18.6127 11.2431 18.7408 11.1991 18.8576C11.1439 19.0784 11.0047 19.6051 10.9495 19.7983C10.938 19.8638 10.9113 19.9257 10.8716 19.979C10.8318 20.0323 10.78 20.0755 10.7205 20.1052C10.661 20.1348 10.5953 20.1501 10.5288 20.1497C10.4623 20.1493 10.3968 20.1333 10.3376 20.103C8.67708 19.4383 7.8948 17.611 7.8948 15.5246C7.8948 12.1087 10.7551 8.01977 16.4782 8.01977C21.0327 8.01977 24.061 11.3516 24.061 14.9151C24.061 19.6051 21.449 23.1314 17.5893 23.1314C17.0124 23.1498 16.4402 23.0225 15.9255 22.7612C15.4109 22.4999 14.9704 22.113 14.6449 21.6364C14.6449 21.6364 13.9514 24.4151 13.8147 24.9407C13.5355 25.8486 13.1235 26.7101 12.5921 27.4975C13.6995 27.8334 14.8501 28.0014 16.0067 27.9966C17.5827 27.9978 19.1436 27.6882 20.5998 27.0854C22.056 26.4826 23.379 25.5985 24.493 24.4837C25.6071 23.3688 26.4903 22.0452 27.092 20.5886C27.6938 19.132 28.0024 17.5709 28 15.9949C27.9985 13.0974 26.9487 10.2982 25.0444 8.11429C23.1401 5.93038 20.51 4.50921 17.6396 4.1132L17.6372 4.112Z"
                                                      fill="#BB0F23"
                                                    />
                                                  </svg>
                                                </li>
                                                <li>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="32"
                                                    height="32"
                                                    viewBox="0 0 32 32"
                                                    fill="none"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M26.3625 10.785C26.3715 11.0182 26.3745 11.2513 26.3745 11.4845C26.3745 18.5541 21.4014 26.7155 12.3073 26.7155C9.51376 26.7155 6.91616 25.8252 4.72754 24.3095C5.11442 24.3519 5.50733 24.3838 5.90626 24.3838C8.2225 24.3838 10.3558 23.5251 12.0481 22.0836C9.88456 22.0518 8.05771 20.4937 7.42765 18.3739C7.73012 18.4375 8.04161 18.4694 8.36015 18.4694C8.80933 18.4694 9.24544 18.4059 9.66347 18.2787C7.39949 17.7911 5.69423 15.629 5.69423 13.0322C5.69423 13.0004 5.69423 12.9897 5.69423 12.9685C6.36147 13.3607 7.12516 13.6043 7.9361 13.6361C6.60765 12.6716 5.73441 11.0288 5.73441 9.17396C5.73441 8.19884 5.97759 7.27668 6.40566 6.48175C8.84349 9.72507 12.4882 11.8555 16.5971 12.0781C16.5127 11.6859 16.4695 11.2727 16.4695 10.8593C16.4695 7.90216 18.6832 5.50671 21.4145 5.50671C22.8364 5.50671 24.1206 6.15335 25.022 7.19206C26.1504 6.95888 27.2076 6.51375 28.1642 5.899C27.7934 7.1497 27.0106 8.19879 25.9877 8.85594C26.9885 8.72875 27.9432 8.44279 28.8285 8.01883C28.1642 9.08933 27.3282 10.0325 26.3625 10.785Z"
                                                      fill="#1EA1F2"
                                                    />
                                                  </svg>
                                                </li>
                                              </ul>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </TabPane>
                                </TabContent>
                              </TabContainer>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Tab.Container>
          </Row>
        </Container>

        {/* 🔔 ToastContainer */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          style={{ fontSize: "15px" }}
        />
      </div>
    </>
  );
};

export default StoreDetailOLD;

// ###########################################################################
// import React, { useEffect, useState } from "react";
// import {
//   Row,
//   Col,
//   Container,
//   Nav,
//   Button,
//   Table,
//   Tab,
//   Form,
//   Image,
//   Dropdown,
//   TabContainer,
//   TabContent,
//   TabPane,
// } from "react-bootstrap";
// import Card from "../../../components/Card";
// import { Link } from "react-router-dom";

// // images
// import storeLogo from "../../../assets/images/store/product-detail/store.png";

// import ProfileHeader from "../../../components/profile-header";
// import profilebg9 from "../../../assets/images/page-img/profile-bg9.jpg";
// import axios from "axios";
// import { webServiceUrl } from "../../../components/apiCall/webserviceurl";

// const StoreDetailOLD = () => {
//   const [iappreciated, setIappreciated] = useState([]);
//   const [Inominated, setInominated] = useState([]);

//   const recognitions = [
//     {
//       id: 1,
//       category: "Collaborative",
//       text: "Always helps classmates with projects and discussions.",
//       name: "Ranjeet Kumar",
//       date: "25-03-2025",
//       color: "text-warning", // Yellow
//     },
//     {
//       id: 2,
//       category: "Responsive",
//       text: "Quick to assist peers with doubts and questions.",
//       name: "Amit Sharma",
//       date: "28-03-2025",
//       color: "text-primary", // Blue
//     },
//     {
//       id: 3,
//       category: "Great Job",
//       text: "Consistently delivers excellent work with dedication.",
//       name: "Neha Verma",
//       date: "30-03-2025",
//       color: "text-success", // Green
//     },
//     {
//       id: 4,
//       category: "Thank you!",
//       text: "Always goes the extra mile to support friends.",
//       name: "Suresh Mehta",
//       date: "01-04-2025",
//       color: "text-danger", // Red
//     },
//     {
//       id: 5,
//       category: "Innovative",
//       text: "Comes up with unique and creative ideas in discussions.",
//       name: "Pooja Singh",
//       date: "02-04-2025",
//       color: "text-info", // Cyan
//     },
//   ];

//   const appreciated = [
//     {
//       id: 1,
//       category: "Collaborative",
//       text: "Always helps classmates with projects and discussions.",
//       name: "Ranjeet Kumar",
//       date: "25-03-2025",
//     },
//     {
//       id: 2,
//       category: "Responsive",
//       text: "Quick to assist peers with doubts and questions.",
//       name: "Amit Sharma",
//       date: "28-03-2025",
//     },
//     {
//       id: 3,
//       category: "Great Job",
//       text: "Consistently delivers excellent work with dedication.",
//       name: "Neha Verma",
//       date: "30-03-2025",
//     },
//     {
//       id: 4,
//       category: "Thank you!",
//       text: "Always goes the extra mile to support friends.",
//       name: "Suresh Mehta",
//       date: "01-04-2025",
//     },
//     {
//       id: 5,
//       category: "Innovative",
//       text: "Comes up with unique and creative ideas in discussions.",
//       name: "Pooja Singh",
//       date: "02-04-2025",
//     },
//   ];

//   const getIappreciated = async () => {
//     try {
//       const userId = localStorage.getItem("userId");
//       console.log(userId, "userid here");

//       const response = await axios.post(webServiceUrl.Iappreciated, {
//         userId: userId,
//       });
//       console.log(response.data);
//       setIappreciated(response.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   // I getINominated
//   const getINominated = async () => {
//     try {
//       const userId = localStorage.getItem("userId");
//       console.log(userId, "userid here");

//       const response = await axios.post(webServiceUrl.Inominated, {
//         userId: userId,
//       });
//       console.log(response.data);
//       setInominated(response.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     getIappreciated();
//     getINominated();
//   }, []);

//   return (
//     <>
//       <ProfileHeader img={profilebg9} />
//       <div id="content-page" className="content-inner">
//         <Container>
//           <Row>
//             <Col md={12} className="mb-4">
//               <div
//                 className="header-title"
//                 style={{ textAlign: "left", width: "100%" }}
//               >
//                 <h1 style={{ textAlign: "center", width: "100%" }}>
//                   Advantage Club
//                 </h1>
//               </div>
//             </Col>
//             <Tab.Container id="left-tabs-example" defaultActiveKey="first">
//               <Col lg={12}>
//                 <Card>
//                   <Card.Body className="p-0">
//                     <div className="user-tabing p-3">
//                       <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
//                         <Nav
//                           variant="pills"
//                           className="d-flex align-items-center text-center profile-forum-items p-0 m-0 w-75"
//                         >
//                           <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="first"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 thumb_up
//                               </i>{" "}
//                               <span>Appreciate</span>
//                             </Nav.Link>
//                           </Col>
//                           <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="second"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 emoji_events
//                               </i>{" "}
//                               <span>Nominate</span>
//                             </Nav.Link>
//                           </Col>
//                           {/* <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="third"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 card_giftcard
//                               </i>{" "}
//                               <span>Greetings</span>
//                             </Nav.Link>
//                           </Col> */}
//                           <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="fourth"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 star
//                               </i>{" "}
//                               <span>My Badges & Values</span>
//                             </Nav.Link>
//                           </Col>
//                         </Nav>
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//               <Col sm={12}>
//                 <Tab.Content className="forum-content">
//                   <Tab.Pane eventKey="first">
//                     {/* <div id="post-modal-data" className="card">
//                       <div className="card-header d-flex justify-content-between border-bottom">
//                         <div className="header-title">
//                           <h5 className="card-title">Appreciate Here</h5>
//                         </div>
//                       </div>
//                       <div className="card-body">
//                         <div className="d-flex align-items-center mb-5">
//                           <form
//                             className="post-text w-100"
//                             // onClick={handleShow}
//                           >
//                             <input
//                               type="text"
//                               className="form-control rounded px-0"
//                               placeholder="Write And Appreciate Your Friends..."
//                               style={{ border: "none" }}
//                             />
//                           </form>
//                         </div>
//                       </div>
//                       <div className="card-body bg-primary-subtle rounded-bottom-3">
//                         <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
//                           <div className="create-post-data">
//                             <ul className="list-inline d-flex flex-wrap justify-content-center align-items-center gap-3 p-0 m-0">
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   thumb_up
//                                 </i>
//                                 <span>Great Job</span> |
//                               </li>
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   favorite
//                                 </i>{" "}
//                                 <span>Thank You</span>|
//                               </li>
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   bolt
//                                 </i>{" "}
//                                 <span>Responsive</span>|
//                               </li>
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   emoji_people
//                                 </i>{" "}
//                                 Respectful
//                               </li>
//                             </ul>
//                           </div>
//                           <div>
//                             <ul className="list-inline m-0 p-0 d-flex align-items-center gap-4">
//                               <li>
//                                 <Link to="#" className="text-body fw-medium">
//                                   Discard
//                                 </Link>
//                               </li>
//                               <li>
//                                 <button
//                                   type="button"
//                                   className="btn btn-primary px-4"
//                                 >
//                                   Post
//                                 </button>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>
//                       </div>
//                     </div> */}
//                     <Card>
//                       <Card.Body>
//                         <div
//                           className="header-title"
//                           style={{ textAlign: "left", width: "100%" }}
//                         >
//                           <h1 style={{ textAlign: "center", width: "100%" }}>
//                             🏆 I Appreciated
//                           </h1>
//                         </div>
//                         <Table
//                           responsive
//                           className="forum-table mb-0 rounded mt-4"
//                         >
//                           <thead className="bg-primary text-white">
//                             <tr>
//                               <th>Name </th>
//                               <th>Message</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {iappreciated.map((item) => (
//                               <tr key={item.id}>
//                                 <td className="col-lg-6">
//                                   <div className="d-flex align-items-center">
//                                     <div className="media-body ">
//                                       <h6 className="mb-0">
//                                         <Link to="#">{item.name}</Link>
//                                       </h6>
//                                     </div>
//                                   </div>
//                                 </td>
//                                 <td className="col-lg-6">
//                                   <h6>{item.message}</h6>
//                                   <p className="mb-0">
//                                     <span
//                                       style={{
//                                         fontSize: "10px",
//                                       }}
//                                     >
//                                       {" "}
//                                       {item.date}
//                                     </span>
//                                   </p>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </Table>
//                       </Card.Body>
//                     </Card>
//                   </Tab.Pane>
//                   <Tab.Pane eventKey="second">
//                     {/* <Card>
//                       <Card.Body className="p-4">
//                         <h4 className="text-center mb-4">Nomination Form</h4>

//                         <Form>
//                           <Form.Group className="mb-3" controlId="nomineeName">
//                             <Form.Label>Enter Name</Form.Label>
//                             <Form.Control
//                               type="text"
//                               placeholder="Enter name"
//                             />
//                           </Form.Group>

//                           <Form.Group
//                             className="mb-3"
//                             controlId="nominationReason"
//                           >
//                             <Form.Label>Write Your Message</Form.Label>
//                             <Form.Control
//                               as="textarea"
//                               rows={4}
//                               placeholder="Why do you nominate this person?"
//                             />
//                           </Form.Group>

//                           <Button
//                             variant="primary"
//                             type="submit"
//                             className="w-100"
//                           >
//                             Submit Nomination
//                           </Button>
//                         </Form>
//                       </Card.Body>
//                     </Card> */}
//                     <Card>
//                       <Card.Body>
//                         <div
//                           className="header-title"
//                           style={{ textAlign: "left", width: "100%" }}
//                         >
//                           <h1 style={{ textAlign: "center", width: "100%" }}>
//                             🏆 I Nominated
//                           </h1>
//                         </div>
//                         <Table
//                           responsive
//                           className="forum-table mb-0 rounded mt-4"
//                         >
//                           <thead className="bg-primary text-white">
//                             <tr>
//                               <th>Nomination</th>
//                               <th>Citation</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {Inominated.map((item) => (
//                               <tr key={item.id}>
//                                 <td className="col-lg-6">
//                                   <div className="d-flex align-items-center">
//                                     <i
//                                       className={`material-symbols-outlined ${
//                                         item.nomination === "Collaborative"
//                                           ? "text-warning"
//                                           : item.nomination === "Responsive"
//                                           ? "text-primary"
//                                           : item.nomination === "Great Job"
//                                           ? "text-success"
//                                           : item.nomination === "Thank you!"
//                                           ? "text-danger"
//                                           : item.nomination === "Innovative"
//                                           ? "text-info"
//                                           : ""
//                                       }`}
//                                       style={{
//                                         fontSize: "2rem",
//                                       }}
//                                     >
//                                       stars
//                                     </i>

//                                     <div className="media-body ms-3">
//                                       <h6 className="mb-0">
//                                         <Link to="#">{item.nomination}</Link>
//                                       </h6>
//                                     </div>
//                                   </div>
//                                 </td>
//                                 <td className="col-lg-6">
//                                   <h6>{item.citation}</h6>
//                                   <p className="mb-0">
//                                     <span className="text-dark me-2">
//                                       {item.name}
//                                     </span>
//                                     <span
//                                       style={{
//                                         fontSize: "10px",
//                                       }}
//                                     >
//                                       {" "}
//                                       {item.date}
//                                     </span>
//                                   </p>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </Table>
//                       </Card.Body>
//                     </Card>
//                   </Tab.Pane>

//                   <Tab.Pane eventKey="third">
//                     <Card>
//                       <Card.Body className="p-4">
//                         <h4 className="text-primary text-center my-2">
//                           🎁 Send a Greeting to Your Friend!
//                         </h4>
//                         <Form>
//                           <Form.Group className="mb-3" controlId="friendName">
//                             <Form.Label>Friend's Name</Form.Label>
//                             <Form.Control
//                               type="text"
//                               placeholder="Enter your friend's name"
//                             />
//                           </Form.Group>

//                           <Form.Group
//                             className="mb-3"
//                             controlId="greetingMessage"
//                           >
//                             <Form.Label>Your Message</Form.Label>
//                             <Form.Control
//                               as="textarea"
//                               rows={3}
//                               placeholder="Write your heartfelt message here..."
//                             />
//                           </Form.Group>

//                           {/* <div className="d-flex justify-content-center gap-2 mb-3">
//                             <Button variant="outline-primary">😊</Button>
//                             <Button variant="outline-success">🎉</Button>
//                             <Button variant="outline-warning">❤️</Button>
//                           </div> */}

//                           <button
//                             type="button"
//                             className="btn btn-primary px-4"
//                           >
//                             Send Greeting
//                           </button>
//                         </Form>

//                         {/* Recent Greetings Section */}
//                         <hr className="my-4" />
//                         <h5 className="text-center my-4">
//                           🗨️ Recent Greetings
//                         </h5>
//                         <div className="recent-greetings">
//                           {[
//                             {
//                               name: "John Doe",
//                               message: "Wishing you a fantastic day! 🎉",
//                             },
//                             {
//                               name: "Jane Smith",
//                               message: "Hope you’re doing great! ❤️",
//                             },
//                             {
//                               name: "Alex Brown",
//                               message: "You’re awesome! 😊",
//                             },
//                           ].map((greeting, index) => (
//                             <div
//                               key={index}
//                               className="mb-3 p-3 bg-light rounded shadow-sm"
//                             >
//                               <strong>{greeting.name}</strong>
//                               <p className="mb-0">{greeting.message}</p>
//                             </div>
//                           ))}
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Tab.Pane>

//                   <Tab.Pane eventKey="fourth">
//                     <Card className="shadow-lg border-0 rounded-4">
//                       <Card.Body className="d-flex flex-column justify-content-center align-items-center py-4">
//                         <h1 className="display-3 fw-bold customText_color">
//                           75%
//                         </h1>
//                         <p className="text-muted fs-5">Advantage Score</p>
//                         <i
//                           className="material-symbols-outlined text-warning"
//                           style={{ fontSize: "3rem" }}
//                         >
//                           stars
//                         </i>
//                       </Card.Body>
//                     </Card>
//                     <Card>
//                       <Card.Body>
//                         <Row className="mt-5 pt-4">
//                           <Col lg={12}>
//                             <div className="product-detail-tabs">
//                               <TabContainer defaultActiveKey={"description"}>
//                                 <Nav
//                                   as="ul"
//                                   className="nav nav-tabs justify-content-center gap-4 mb-3 gap-lg-5 border-bottom"
//                                   id="product-tab"
//                                   role="tablist"
//                                 >
//                                   <li className="nav-item" role="presentation">
//                                     <Nav.Link
//                                       to="#"
//                                       className="nav-link bg-transparent px-0 py-2 fs-5 rounded-0"
//                                       data-bs-toggle="tab"
//                                       data-bs-target="#description"
//                                       eventKey={"description"}
//                                       role="tab"
//                                       aria-selected="true"
//                                     >
//                                       Nomination Received
//                                     </Nav.Link>
//                                   </li>
//                                   <li className="nav-item" role="presentation">
//                                     <Nav.Link
//                                       to="#"
//                                       className="nav-link bg-transparent px-0 py-2 fs-5 rounded-0"
//                                       data-bs-toggle="tab"
//                                       data-bs-target="#additional-information"
//                                       role="tab"
//                                       aria-selected="false"
//                                       eventKey={"additional-information"}
//                                     >
//                                       Appreciation received
//                                     </Nav.Link>
//                                   </li>
//                                 </Nav>
//                                 <TabContent id="product-tab-content">
//                                   <TabPane
//                                     className="tab-pane fade show"
//                                     id="description"
//                                     eventKey={"description"}
//                                     role="tabpanel"
//                                   >
//                                     <Card>
//                                       <Card.Body>
//                                         <Table
//                                           responsive
//                                           className="forum-table mb-0 rounded mt-4"
//                                         >
//                                           <thead className="bg-primary text-white">
//                                             <tr>
//                                               <th>Nomination</th>
//                                               <th>Citation</th>
//                                             </tr>
//                                           </thead>
//                                           <tbody>
//                                             {Inominated.map((item) => (
//                                               <tr key={item.id}>
//                                                 <td className="col-lg-6">
//                                                   <div className="d-flex align-items-center">
//                                                     <i
//                                                       className={`material-symbols-outlined ${
//                                                         item.nomination ===
//                                                         "Collaborative"
//                                                           ? "text-warning"
//                                                           : item.nomination ===
//                                                             "Responsive"
//                                                           ? "text-primary"
//                                                           : item.nomination ===
//                                                             "Great Job"
//                                                           ? "text-success"
//                                                           : item.nomination ===
//                                                             "Thank you!"
//                                                           ? "text-danger"
//                                                           : item.nomination ===
//                                                             "Innovative"
//                                                           ? "text-info"
//                                                           : ""
//                                                       }`}
//                                                       style={{
//                                                         fontSize: "2rem",
//                                                       }}
//                                                     >
//                                                       stars
//                                                     </i>

//                                                     <div className="media-body ms-3">
//                                                       <h6 className="mb-0">
//                                                         <Link to="#">
//                                                           {item.nomination}
//                                                         </Link>
//                                                       </h6>
//                                                     </div>
//                                                   </div>
//                                                 </td>
//                                                 <td className="col-lg-6">
//                                                   <h6>{item.citation}</h6>
//                                                   <p className="mb-0">
//                                                     <span className="text-dark me-2">
//                                                       {item.name}
//                                                     </span>
//                                                     <span
//                                                       style={{
//                                                         fontSize: "10px",
//                                                       }}
//                                                     >
//                                                       {" "}
//                                                       {item.date}
//                                                     </span>
//                                                   </p>
//                                                 </td>
//                                               </tr>
//                                             ))}
//                                           </tbody>
//                                         </Table>
//                                       </Card.Body>
//                                     </Card>
//                                   </TabPane>

//                                   {/* Learning Outcum */}
//                                   <TabPane
//                                     className="tab-pane fade"
//                                     id="additional-information"
//                                     role="tabpanel"
//                                     eventKey={"additional-information"}
//                                   >
//                                     <Table
//                                       responsive
//                                       className="forum-table mb-0 rounded mt-4"
//                                     >
//                                       <thead className="bg-primary text-white">
//                                         <tr>
//                                           <th>Name </th>
//                                           <th>Message</th>
//                                         </tr>
//                                       </thead>
//                                       <tbody>
//                                         {iappreciated.map((item) => (
//                                           <tr key={item.id}>
//                                             <td className="col-lg-6">
//                                               <div className="d-flex align-items-center">
//                                                 <div className="media-body ">
//                                                   <h6 className="mb-0">
//                                                     <Link to="#">
//                                                       {item.name}
//                                                     </Link>
//                                                   </h6>
//                                                 </div>
//                                               </div>
//                                             </td>
//                                             <td className="col-lg-6">
//                                               <h6>{item.message}</h6>
//                                               <p className="mb-0">
//                                                 <span
//                                                   style={{
//                                                     fontSize: "10px",
//                                                   }}
//                                                 >
//                                                   {" "}
//                                                   {item.date}
//                                                 </span>
//                                               </p>
//                                             </td>
//                                           </tr>
//                                         ))}
//                                       </tbody>
//                                     </Table>
//                                   </TabPane>

//                                   <TabPane
//                                     className="tab-pane fade"
//                                     id="reviews"
//                                     role="tabpanel"
//                                     eventKey={"reviews"}
//                                   >
//                                     <div>
//                                       <Container>
//                                         <Row className="">
//                                           <Col lg="6" className="mt-4">
//                                             <Card className="shadow h-100">
//                                               <Card.Header className="d-flex justify-content-between">
//                                                 <div className="header-title">
//                                                   <h4 className="card-title">
//                                                     Day 1: Introduction to Java
//                                                     & Basics (5 Hours)
//                                                   </h4>
//                                                 </div>
//                                               </Card.Header>
//                                               <Card.Body className="pt-0">
//                                                 <ul className="iq-timeline ms-1">
//                                                   <li>
//                                                     <div className="timeline-dots"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Introduction to
//                                                         Programming & Java (1
//                                                         Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         24 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>Why learn Java?</p>
//                                                       <p>
//                                                         History & evolution of
//                                                         Java
//                                                       </p>
//                                                       <p>
//                                                         Applications of Java
//                                                         (Web, Mobile, IoT, AI)
//                                                       </p>
//                                                       <p>
//                                                         Setting up Java (JDK &
//                                                         IDEs like
//                                                         Eclipse/IntelliJ/VS
//                                                         Code)
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-success"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Basic Syntax & First
//                                                         Java Program (1 Hour)
//                                                       </h6>
//                                                       <small>
//                                                         23 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         {" "}
//                                                         Structure of a Java
//                                                         program
//                                                       </p>
//                                                       <p>
//                                                         Writing & running
//                                                         "Hello, World!"
//                                                       </p>
//                                                       <p>
//                                                         Comments & coding
//                                                         standards
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-danger"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Variables, Data Types &
//                                                         Operators (1 Hour)
//                                                       </h6>
//                                                       <small>
//                                                         20 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Primitive &
//                                                         Non-primitive data types
//                                                       </p>
//                                                       <p>
//                                                         Declaring & initializing
//                                                         variables
//                                                       </p>
//                                                       <p>
//                                                         Arithmetic, relational,
//                                                         logical operators
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-primary"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         User Input & Output (1
//                                                         Hour)
//                                                       </h6>
//                                                       <small>
//                                                         19 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Scanner class for user
//                                                         input
//                                                       </p>
//                                                       <p>
//                                                         System.out.print() and
//                                                         System.out.println()
//                                                       </p>
//                                                       <p>
//                                                         Simple console-based
//                                                         programs
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-info"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Hands-on Coding & Q&A (1
//                                                         Hour)
//                                                       </h6>
//                                                       <small>
//                                                         15 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block w-100">
//                                                       <p>
//                                                         o Mini exercises
//                                                         (printing user details,
//                                                         calculating area of a
//                                                         circle)
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                 </ul>
//                                               </Card.Body>
//                                             </Card>
//                                           </Col>
//                                           <Col lg="6" className="mt-4">
//                                             <Card className="shadow h-100">
//                                               <Card.Header className="d-flex justify-content-between">
//                                                 <div className="header-title">
//                                                   <h4 className="card-title">
//                                                     Day 2: Control Flow & Loops
//                                                     (5 Hours)
//                                                   </h4>
//                                                 </div>
//                                               </Card.Header>
//                                               <Card.Body className="pt-0">
//                                                 <ul className="iq-timeline ms-1">
//                                                   <li>
//                                                     <div className="timeline-dots"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Decision Making in Java
//                                                         (1 Hour)
//                                                       </h6>
//                                                       <small>
//                                                         25 November 2019
//                                                       </small>
//                                                     </div>
//                                                     {/* <div className="d-flex justify-content-end">
//                                             <small>25 November 2019</small>
//                                           </div> */}
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         if, if-else, if-else-if,
//                                                         switch-case
//                                                       </p>
//                                                       <p>
//                                                         Practical examples
//                                                         (grading system, traffic
//                                                         light program)
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-success"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Loops in Java (1 Hour)
//                                                       </h6>
//                                                       <small>
//                                                         24 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         for, while, do-while
//                                                         loops
//                                                       </p>
//                                                       <p>
//                                                         Loop control statements
//                                                         (break, continue)
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-danger"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Nested Loops & Patterns
//                                                         (1 Hour)
//                                                       </h6>
//                                                       <small>
//                                                         23 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Printing patterns
//                                                         (stars, numbers)
//                                                       </p>
//                                                       <p>
//                                                         Fibonacci series,
//                                                         factorial calculation
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-primary"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Hands-on Coding (1 Hour)
//                                                       </h6>
//                                                       <small>
//                                                         22 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Implementing a simple
//                                                         number guessing game
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-info"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Q&A & Debugging Practice
//                                                         (1 Hour)
//                                                       </h6>
//                                                       <small>
//                                                         21 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Identifying errors in
//                                                         code
//                                                       </p>
//                                                       <p>
//                                                         Fixing logical mistakes
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                 </ul>
//                                               </Card.Body>
//                                             </Card>
//                                           </Col>
//                                           <Col lg="6" className="mt-4">
//                                             {/* Day 3: Functions & Arrays */}
//                                             <Card className="shadow h-100">
//                                               <Card.Header className="d-flex justify-content-between">
//                                                 <div className="header-title">
//                                                   <h4 className="card-title">
//                                                     Day 3: Functions & Arrays (5
//                                                     Hours)
//                                                   </h4>
//                                                 </div>
//                                               </Card.Header>
//                                               <Card.Body className="pt-0">
//                                                 <ul className="iq-timeline ms-1">
//                                                   <li>
//                                                     <div className="timeline-dots"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Methods in Java (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         25 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Defining & calling
//                                                         methods
//                                                       </p>
//                                                       <p>
//                                                         Method parameters &
//                                                         return types
//                                                       </p>
//                                                       <p>
//                                                         Static vs non-static
//                                                         methods
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-success"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Arrays (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         24 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Single-dimensional &
//                                                         multi-dimensional arrays
//                                                       </p>
//                                                       <p>
//                                                         Array traversal &
//                                                         manipulation
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-danger"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Strings & String Methods
//                                                         (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         23 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         String concatenation,
//                                                         length, comparison
//                                                       </p>
//                                                       <p>
//                                                         StringBuilder for
//                                                         efficient manipulation
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-primary"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Hands-on Coding (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Creating a mini contact
//                                                         book using arrays &
//                                                         methods
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-info"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Q&A & Debugging Practice
//                                                         (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Common errors &
//                                                         debugging techniques
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                 </ul>
//                                               </Card.Body>
//                                             </Card>
//                                           </Col>

//                                           <Col lg="6" className="mt-4">
//                                             {/* Day 4: Object-Oriented Programming (OOP) */}
//                                             <Card className="shadow h-100">
//                                               <Card.Header className="d-flex justify-content-between">
//                                                 <div className="header-title">
//                                                   <h4 className="card-title">
//                                                     Day 4: Object-Oriented
//                                                     Programming (OOP) (5 Hours)
//                                                   </h4>
//                                                 </div>
//                                               </Card.Header>
//                                               <Card.Body className="pt-0">
//                                                 <ul className="iq-timeline ms-1">
//                                                   <li>
//                                                     <div className="timeline-dots"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Classes & Objects (1
//                                                         Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         26 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Creating & using objects
//                                                       </p>
//                                                       <p>
//                                                         Constructors & this
//                                                         keyword
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-success"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Encapsulation &
//                                                         Inheritance (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         25 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Private variables &
//                                                         getter/setter methods
//                                                       </p>
//                                                       <p>
//                                                         Inheriting properties
//                                                         from parent class
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-danger"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Polymorphism & Method
//                                                         Overloading (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         24 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Compile-time vs runtime
//                                                         polymorphism
//                                                       </p>
//                                                       <p>Method overloading</p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-primary"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Hands-on Coding (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Creating a student
//                                                         management system with
//                                                         OOP
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-info"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Q&A & Debugging (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Exploring real-world OOP
//                                                         examples
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                 </ul>
//                                               </Card.Body>
//                                             </Card>
//                                           </Col>

//                                           <Col lg="6" className="mt-4">
//                                             {/* Day 5: Mini Project & Final Assessment */}
//                                             <Card className="shadow h-100">
//                                               <Card.Header className="d-flex justify-content-between">
//                                                 <div className="header-title">
//                                                   <h4 className="card-title">
//                                                     Day 5: Mini Project & Final
//                                                     Assessment (5 Hours)
//                                                   </h4>
//                                                 </div>
//                                               </Card.Header>
//                                               <Card.Body className="pt-0">
//                                                 <ul className="iq-timeline ms-1">
//                                                   <li>
//                                                     <div className="timeline-dots"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Introduction to Java
//                                                         Mini Project (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         27 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Explaining the project:
//                                                         Student Grade Management
//                                                         System
//                                                       </p>
//                                                       <p>
//                                                         Requirements & planning
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-success"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Project Implementation
//                                                         (2 Hours)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         26 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Creating classes for
//                                                         students
//                                                       </p>
//                                                       <p>
//                                                         Adding features (marks
//                                                         entry, grading,
//                                                         displaying results)
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-danger"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Testing & Debugging (1
//                                                         Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-flex justify-content-end">
//                                                       <small>
//                                                         25 November 2019
//                                                       </small>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>Running test cases</p>
//                                                       <p>Fixing issues</p>
//                                                     </div>
//                                                   </li>
//                                                   <li>
//                                                     <div className="timeline-dots border-primary"></div>
//                                                     <div className="d-flex align-items-center justify-content-between">
//                                                       <h6 className="mb-1">
//                                                         Final Presentation &
//                                                         Assessment (1 Hour)
//                                                       </h6>
//                                                     </div>
//                                                     <div className="d-inline-block timeline-icon w-100">
//                                                       <p>
//                                                         Students showcase their
//                                                         projects
//                                                       </p>
//                                                       <p>
//                                                         Q&A session & feedback
//                                                       </p>
//                                                     </div>
//                                                   </li>
//                                                 </ul>
//                                               </Card.Body>
//                                             </Card>
//                                           </Col>
//                                         </Row>
//                                       </Container>
//                                     </div>
//                                   </TabPane>
//                                   <TabPane
//                                     eventKey={"storedetail"}
//                                     className="tab-pane fade"
//                                     id="storedetail"
//                                     role="tabpanel"
//                                   >
//                                     <div className="d-flex align-items-center gap-3">
//                                       <img
//                                         src={storeLogo}
//                                         alt=""
//                                         loading="lazy"
//                                       />
//                                       <div>
//                                         <h5 className="text capitalize fw-semibold">
//                                           voltt scale store
//                                         </h5>
//                                         <div className="d-flex align-items-center w-100 mt-2 flex-wrap">
//                                           <svg
//                                             className="icon-24"
//                                             width="24"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                           >
//                                             <path
//                                               fillRule="evenodd"
//                                               clipRule="evenodd"
//                                               d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
//                                               fill="#FFD329"
//                                             ></path>
//                                           </svg>
//                                           <svg
//                                             className="icon-24"
//                                             width="24"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                           >
//                                             <path
//                                               fillRule="evenodd"
//                                               clipRule="evenodd"
//                                               d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
//                                               fill="#FFD329"
//                                             ></path>
//                                           </svg>
//                                           <svg
//                                             className="icon-24"
//                                             width="24"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                           >
//                                             <path
//                                               fillRule="evenodd"
//                                               clipRule="evenodd"
//                                               d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
//                                               fill="#FFD329"
//                                             ></path>
//                                           </svg>
//                                           <svg
//                                             className="icon-24"
//                                             width="24"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                           >
//                                             <path
//                                               fillRule="evenodd"
//                                               clipRule="evenodd"
//                                               d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
//                                               fill="#FFD329"
//                                             ></path>
//                                           </svg>
//                                           <svg
//                                             className="icon-24"
//                                             width="24"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                           >
//                                             <path
//                                               fillRule="evenodd"
//                                               clipRule="evenodd"
//                                               d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z"
//                                               fill="#6c757d"
//                                             ></path>
//                                           </svg>
//                                           <span className="ms-1 font-size-14 fw-semibold text-capitalize">
//                                             (4 customer review)
//                                           </span>
//                                         </div>
//                                       </div>
//                                     </div>
//                                     <div className="table-responsive store-detail-table">
//                                       <table className="mt-5 pt-2">
//                                         <tbody>
//                                           <tr>
//                                             <th className="w-25">
//                                               <h6 className="text-capitalize fw-semibold">
//                                                 address:
//                                               </h6>
//                                             </th>
//                                             <td className="w-75">
//                                               492 Devon StreetMissoula, MT
//                                               59801, united states
//                                             </td>
//                                           </tr>
//                                           <tr>
//                                             <th className="w-25">
//                                               <h6 className="text-capitalize fw-semibold">
//                                                 time:
//                                               </h6>
//                                             </th>
//                                             <td className="w-75">
//                                               <h6 className="text-capitalize fw-normal mb-2">
//                                                 mon to fri:
//                                                 <span className="text-body ms-2">
//                                                   08:00 AM - 16:00 PM
//                                                 </span>
//                                               </h6>
//                                               <h6 className="text-capitalize fw-normal">
//                                                 Weekends:
//                                                 <span className="text-body ms-2">
//                                                   Closed
//                                                 </span>
//                                               </h6>
//                                             </td>
//                                           </tr>
//                                           <tr>
//                                             <th className="w-25">
//                                               <h6 className="text-capitalize fw-semibold">
//                                                 number:
//                                               </h6>
//                                             </th>
//                                             <td className="w-75 text-primary">
//                                               (+16) 813 021 021
//                                             </td>
//                                           </tr>
//                                           <tr>
//                                             <th className="w-25">
//                                               <h6 className="text-capitalize fw-semibold">
//                                                 Follow Us:
//                                               </h6>
//                                             </th>
//                                             <td className="w-75">
//                                               <ul className="list-inline d-flex align-items-center gap-2 mb-0">
//                                                 <li>
//                                                   <svg
//                                                     xmlns="http://www.w3.org/2000/svg"
//                                                     width="32"
//                                                     height="32"
//                                                     viewBox="0 0 32 32"
//                                                     fill="none"
//                                                   >
//                                                     <path
//                                                       d="M14 27.8667C8.33333 26.8667 4 21.9333 4 16C4 9.4 9.4 4 16 4C22.6 4 28 9.4 28 16C28 21.9333 23.6667 26.8667 18 27.8667L17.3333 27.3333H14.6667L14 27.8667Z"
//                                                       fill="url(#paint0_linear_963_723)"
//                                                     />
//                                                     <path
//                                                       d="M20.6667 19.3334L21.2 16H18V13.6667C18 12.7334 18.3333 12 19.8 12H21.3333V8.93335C20.4667 8.80002 19.5333 8.66669 18.6667 8.66669C15.9333 8.66669 14 10.3334 14 13.3334V16H11V19.3334H14V27.8C14.6667 27.9334 15.3333 28 16 28C16.6667 28 17.3333 27.9334 18 27.8V19.3334H20.6667Z"
//                                                       fill="white"
//                                                     />
//                                                     <defs>
//                                                       <linearGradient
//                                                         id="paint0_linear_963_723"
//                                                         x1="16"
//                                                         y1="27.1693"
//                                                         x2="16"
//                                                         y2="4"
//                                                         gradientUnits="userSpaceOnUse"
//                                                       >
//                                                         <stop stopColor="#0062E0" />
//                                                         <stop
//                                                           offset="1"
//                                                           stopColor="#19AFFF"
//                                                         />
//                                                       </linearGradient>
//                                                     </defs>
//                                                   </svg>
//                                                 </li>
//                                                 <li>
//                                                   <svg
//                                                     xmlns="http://www.w3.org/2000/svg"
//                                                     width="32"
//                                                     height="32"
//                                                     viewBox="0 0 32 32"
//                                                     fill="none"
//                                                   >
//                                                     <path
//                                                       d="M16.0003 4.36365C12.8401 4.36365 12.4435 4.37747 11.2023 4.43395C9.9636 4.49068 9.11805 4.6868 8.37819 4.97456C7.61288 5.27177 6.96369 5.66934 6.31692 6.31637C5.66967 6.96316 5.2721 7.61237 4.97393 8.37747C4.68545 9.11759 4.4891 9.96341 4.43334 11.2017C4.37783 12.4429 4.36328 12.8398 4.36328 16C4.36328 19.1603 4.37734 19.5556 4.43358 20.7969C4.49055 22.0356 4.68667 22.8812 4.97417 23.6211C5.27162 24.3864 5.66918 25.0356 6.31619 25.6824C6.96272 26.3297 7.61191 26.7283 8.37674 27.0255C9.11708 27.3132 9.96287 27.5093 11.2014 27.5661C12.4426 27.6226 12.8389 27.6364 15.9988 27.6364C19.1592 27.6364 19.5546 27.6226 20.7958 27.5661C22.0345 27.5093 22.881 27.3132 23.6214 27.0255C24.3864 26.7283 25.0347 26.3297 25.6812 25.6824C26.3284 25.0356 26.726 24.3864 27.0242 23.6213C27.3102 22.8812 27.5066 22.0354 27.5648 20.7971C27.6205 19.5559 27.6351 19.1603 27.6351 16C27.6351 12.8398 27.6205 12.4432 27.5648 11.202C27.5066 9.96316 27.3102 9.11759 27.0242 8.37771C26.726 7.61237 26.3284 6.96316 25.6812 6.31637C25.0339 5.6691 24.3867 5.27153 23.6206 4.97456C22.8788 4.6868 22.0328 4.49068 20.7941 4.43395C19.5529 4.37747 19.1577 4.36365 15.9966 4.36365H16.0003ZM14.9564 6.46062C15.2662 6.46013 15.6119 6.46062 16.0003 6.46062C19.1071 6.46062 19.4753 6.47177 20.7022 6.52753C21.8367 6.57941 22.4524 6.76898 22.8626 6.92825C23.4056 7.13916 23.7928 7.39128 24.1998 7.79856C24.607 8.20583 24.8591 8.59371 25.0705 9.13674C25.2298 9.54643 25.4196 10.1622 25.4712 11.2967C25.527 12.5234 25.5391 12.8919 25.5391 15.9973C25.5391 19.1028 25.527 19.4713 25.4712 20.698C25.4194 21.8325 25.2298 22.4483 25.0705 22.858C24.8596 23.401 24.607 23.7876 24.1998 24.1947C23.7925 24.6019 23.4059 24.8541 22.8626 25.065C22.4529 25.225 21.8367 25.4141 20.7022 25.466C19.4756 25.5217 19.1071 25.5338 16.0003 25.5338C12.8932 25.5338 12.525 25.5217 11.2983 25.466C10.1638 25.4136 9.54809 25.224 9.13768 25.0647C8.59467 24.8538 8.2068 24.6017 7.79954 24.1944C7.39228 23.7872 7.14017 23.4003 6.92878 22.857C6.76951 22.4473 6.5797 21.8315 6.52806 20.697C6.47231 19.4703 6.46116 19.1018 6.46116 15.9944C6.46116 12.887 6.47231 12.5205 6.52806 11.2938C6.57994 10.1593 6.76951 9.54353 6.92878 9.13334C7.13968 8.59031 7.39228 8.20244 7.79954 7.79516C8.2068 7.38789 8.59467 7.13577 9.13768 6.92437C9.54785 6.76437 10.1638 6.57528 11.2983 6.52316C12.3718 6.47468 12.7878 6.46013 14.9564 6.45771V6.46062ZM22.2115 8.39274C21.4406 8.39274 20.8151 9.01747 20.8151 9.78862C20.8151 10.5595 21.4406 11.185 22.2115 11.185C22.9824 11.185 23.6078 10.5595 23.6078 9.78862C23.6078 9.01771 22.9824 8.39225 22.2115 8.39225V8.39274ZM16.0003 10.0243C12.7002 10.0243 10.0247 12.6999 10.0247 16C10.0247 19.3001 12.7002 21.9746 16.0003 21.9746C19.3003 21.9746 21.9749 19.3001 21.9749 16C21.9749 12.6999 19.3 10.0243 16 10.0243H16.0003ZM16.0003 12.1212C18.1423 12.1212 19.8789 13.8577 19.8789 16C19.8789 18.1421 18.1423 19.8788 16.0003 19.8788C13.858 19.8788 12.1216 18.1421 12.1216 16C12.1216 13.8577 13.858 12.1212 16.0003 12.1212Z"
//                                                       fill="url(#paint0_radial_963_724)"
//                                                     />
//                                                     <path
//                                                       d="M16.0003 4.36365C12.8401 4.36365 12.4435 4.37747 11.2023 4.43395C9.9636 4.49068 9.11805 4.6868 8.37819 4.97456C7.61288 5.27177 6.96369 5.66934 6.31692 6.31637C5.66967 6.96316 5.2721 7.61237 4.97393 8.37747C4.68545 9.11759 4.4891 9.96341 4.43334 11.2017C4.37783 12.4429 4.36328 12.8398 4.36328 16C4.36328 19.1603 4.37734 19.5556 4.43358 20.7969C4.49055 22.0356 4.68667 22.8812 4.97417 23.6211C5.27162 24.3864 5.66918 25.0356 6.31619 25.6824C6.96272 26.3297 7.61191 26.7283 8.37674 27.0255C9.11708 27.3132 9.96287 27.5093 11.2014 27.5661C12.4426 27.6226 12.8389 27.6364 15.9988 27.6364C19.1592 27.6364 19.5546 27.6226 20.7958 27.5661C22.0345 27.5093 22.881 27.3132 23.6214 27.0255C24.3864 26.7283 25.0347 26.3297 25.6812 25.6824C26.3284 25.0356 26.726 24.3864 27.0242 23.6213C27.3102 22.8812 27.5066 22.0354 27.5648 20.7971C27.6205 19.5559 27.6351 19.1603 27.6351 16C27.6351 12.8398 27.6205 12.4432 27.5648 11.202C27.5066 9.96316 27.3102 9.11759 27.0242 8.37771C26.726 7.61237 26.3284 6.96316 25.6812 6.31637C25.0339 5.6691 24.3867 5.27153 23.6206 4.97456C22.8788 4.6868 22.0328 4.49068 20.7941 4.43395C19.5529 4.37747 19.1577 4.36365 15.9966 4.36365H16.0003ZM14.9564 6.46062C15.2662 6.46013 15.6119 6.46062 16.0003 6.46062C19.1071 6.46062 19.4753 6.47177 20.7022 6.52753C21.8367 6.57941 22.4524 6.76898 22.8626 6.92825C23.4056 7.13916 23.7928 7.39128 24.1998 7.79856C24.607 8.20583 24.8591 8.59371 25.0705 9.13674C25.2298 9.54643 25.4196 10.1622 25.4712 11.2967C25.527 12.5234 25.5391 12.8919 25.5391 15.9973C25.5391 19.1028 25.527 19.4713 25.4712 20.698C25.4194 21.8325 25.2298 22.4483 25.0705 22.858C24.8596 23.401 24.607 23.7876 24.1998 24.1947C23.7925 24.6019 23.4059 24.8541 22.8626 25.065C22.4529 25.225 21.8367 25.4141 20.7022 25.466C19.4756 25.5217 19.1071 25.5338 16.0003 25.5338C12.8932 25.5338 12.525 25.5217 11.2983 25.466C10.1638 25.4136 9.54809 25.224 9.13768 25.0647C8.59467 24.8538 8.2068 24.6017 7.79954 24.1944C7.39228 23.7872 7.14017 23.4003 6.92878 22.857C6.76951 22.4473 6.5797 21.8315 6.52806 20.697C6.47231 19.4703 6.46116 19.1018 6.46116 15.9944C6.46116 12.887 6.47231 12.5205 6.52806 11.2938C6.57994 10.1593 6.76951 9.54353 6.92878 9.13334C7.13968 8.59031 7.39228 8.20244 7.79954 7.79516C8.2068 7.38789 8.59467 7.13577 9.13768 6.92437C9.54785 6.76437 10.1638 6.57528 11.2983 6.52316C12.3718 6.47468 12.7878 6.46013 14.9564 6.45771V6.46062ZM22.2115 8.39274C21.4406 8.39274 20.8151 9.01747 20.8151 9.78862C20.8151 10.5595 21.4406 11.185 22.2115 11.185C22.9824 11.185 23.6078 10.5595 23.6078 9.78862C23.6078 9.01771 22.9824 8.39225 22.2115 8.39225V8.39274ZM16.0003 10.0243C12.7002 10.0243 10.0247 12.6999 10.0247 16C10.0247 19.3001 12.7002 21.9746 16.0003 21.9746C19.3003 21.9746 21.9749 19.3001 21.9749 16C21.9749 12.6999 19.3 10.0243 16 10.0243H16.0003ZM16.0003 12.1212C18.1423 12.1212 19.8789 13.8577 19.8789 16C19.8789 18.1421 18.1423 19.8788 16.0003 19.8788C13.858 19.8788 12.1216 18.1421 12.1216 16C12.1216 13.8577 13.858 12.1212 16.0003 12.1212Z"
//                                                       fill="url(#paint1_radial_963_724)"
//                                                     />
//                                                     <defs>
//                                                       <radialGradient
//                                                         id="paint0_radial_963_724"
//                                                         cx="0"
//                                                         cy="0"
//                                                         r="1"
//                                                         gradientUnits="userSpaceOnUse"
//                                                         gradientTransform="translate(10.5449 29.4289) rotate(-90) scale(23.065 21.4514)"
//                                                       >
//                                                         <stop stopColor="#FFDD55" />
//                                                         <stop
//                                                           offset="0.1"
//                                                           stopColor="#FFDD55"
//                                                         />
//                                                         <stop
//                                                           offset="0.5"
//                                                           stopColor="#FF543E"
//                                                         />
//                                                         <stop
//                                                           offset="1"
//                                                           stopColor="#C837AB"
//                                                         />
//                                                       </radialGradient>
//                                                       <radialGradient
//                                                         id="paint1_radial_963_724"
//                                                         cx="0"
//                                                         cy="0"
//                                                         r="1"
//                                                         gradientUnits="userSpaceOnUse"
//                                                         gradientTransform="translate(0.465135 6.04018) rotate(78.6811) scale(10.3101 42.4972)"
//                                                       >
//                                                         <stop stopColor="#3771C8" />
//                                                         <stop
//                                                           offset="0.128"
//                                                           stopColor="#3771C8"
//                                                         />
//                                                         <stop
//                                                           offset="1"
//                                                           stopColor="#6600FF"
//                                                           stopOpacity="0"
//                                                         />
//                                                       </radialGradient>
//                                                     </defs>
//                                                   </svg>
//                                                 </li>
//                                                 <li>
//                                                   <svg
//                                                     xmlns="http://www.w3.org/2000/svg"
//                                                     width="32"
//                                                     height="32"
//                                                     viewBox="0 0 32 32"
//                                                     fill="none"
//                                                   >
//                                                     <path
//                                                       d="M4.66699 6.27557C4.66699 5.38701 5.38732 4.66669 6.27588 4.66669H25.7248C26.6133 4.66669 27.3337 5.38701 27.3337 6.27557V25.7244C27.3337 26.613 26.6133 27.3333 25.7248 27.3333H6.27588C5.38732 27.3333 4.66699 26.613 4.66699 25.7244V6.27557Z"
//                                                       fill="#0A66C2"
//                                                     />
//                                                     <path
//                                                       d="M9.75441 11.7059C10.8404 11.7059 11.7207 10.8255 11.7207 9.73952C11.7207 8.65355 10.8404 7.77319 9.75441 7.77319C8.66844 7.77319 7.78809 8.65355 7.78809 9.73952C7.78809 10.8255 8.66844 11.7059 9.75441 11.7059Z"
//                                                       fill="white"
//                                                     />
//                                                     <path
//                                                       d="M13.5216 13.159H16.7804V14.6519C16.7804 14.6519 17.6647 12.8833 20.0709 12.8833C22.2173 12.8833 23.9953 13.9406 23.9953 17.1635V23.9597H20.6182V17.987C20.6182 16.0858 19.6032 15.8767 18.8297 15.8767C17.2246 15.8767 16.9498 17.2613 16.9498 18.235V23.9597H13.5216V13.159Z"
//                                                       fill="white"
//                                                     />
//                                                     <path
//                                                       d="M8.04032 13.159H11.4685V23.9597H8.04032V13.159Z"
//                                                       fill="white"
//                                                     />
//                                                   </svg>
//                                                 </li>
//                                                 <li>
//                                                   <svg
//                                                     xmlns="http://www.w3.org/2000/svg"
//                                                     width="32"
//                                                     height="32"
//                                                     viewBox="0 0 32 32"
//                                                     fill="none"
//                                                   >
//                                                     <path
//                                                       d="M17.6372 4.112C14.7664 3.71708 11.8497 4.37422 9.42555 5.96205C7.00144 7.54988 5.23369 9.96118 4.44872 12.7507C3.66374 15.5402 3.91457 18.5195 5.15488 21.1385C6.39519 23.7575 8.54121 25.8393 11.1967 26.9995C11.1249 26.0779 11.1908 25.1506 11.3922 24.2484C11.6142 23.2417 12.9472 17.6938 12.9472 17.6938C12.6818 17.0988 12.5491 16.4532 12.5585 15.8017C12.5585 14.02 13.5867 12.6906 14.8657 12.6906C15.0955 12.6873 15.3233 12.7334 15.5336 12.826C15.7439 12.9185 15.9319 13.0553 16.0846 13.227C16.2374 13.3986 16.3514 13.6012 16.4189 13.8208C16.4864 14.0405 16.5058 14.2721 16.4758 14.4999C16.4758 15.5798 15.7823 17.2139 15.42 18.7473C15.3484 19.0285 15.3438 19.3226 15.4067 19.6059C15.4696 19.8891 15.5982 20.1537 15.7821 20.3782C15.9659 20.6027 16.2 20.7809 16.4653 20.8983C16.7307 21.0158 17.0199 21.0693 17.3097 21.0545C19.5869 21.0545 21.1131 18.1378 21.1131 14.6943C21.1131 12.0547 19.365 10.0774 16.1423 10.0774C15.3713 10.0475 14.6022 10.1745 13.8818 10.4509C13.1613 10.7272 12.5046 11.1471 11.9514 11.685C11.3982 12.223 10.9601 12.8677 10.6637 13.5801C10.3674 14.2925 10.2188 15.0578 10.2272 15.8293C10.1929 16.6852 10.469 17.5246 11.0047 18.1929C11.1048 18.2677 11.1779 18.3729 11.213 18.4928C11.248 18.6127 11.2431 18.7408 11.1991 18.8576C11.1439 19.0784 11.0047 19.6051 10.9495 19.7983C10.938 19.8638 10.9113 19.9257 10.8716 19.979C10.8318 20.0323 10.78 20.0755 10.7205 20.1052C10.661 20.1348 10.5953 20.1501 10.5288 20.1497C10.4623 20.1493 10.3968 20.1333 10.3376 20.103C8.67708 19.4383 7.8948 17.611 7.8948 15.5246C7.8948 12.1087 10.7551 8.01977 16.4782 8.01977C21.0327 8.01977 24.061 11.3516 24.061 14.9151C24.061 19.6051 21.449 23.1314 17.5893 23.1314C17.0124 23.1498 16.4402 23.0225 15.9255 22.7612C15.4109 22.4999 14.9704 22.113 14.6449 21.6364C14.6449 21.6364 13.9514 24.4151 13.8147 24.9407C13.5355 25.8486 13.1235 26.7101 12.5921 27.4975C13.6995 27.8334 14.8501 28.0014 16.0067 27.9966C17.5827 27.9978 19.1436 27.6882 20.5998 27.0854C22.056 26.4826 23.379 25.5985 24.493 24.4837C25.6071 23.3688 26.4903 22.0452 27.092 20.5886C27.6938 19.132 28.0024 17.5709 28 15.9949C27.9985 13.0974 26.9487 10.2982 25.0444 8.11429C23.1401 5.93038 20.51 4.50921 17.6396 4.1132L17.6372 4.112Z"
//                                                       fill="#BB0F23"
//                                                     />
//                                                   </svg>
//                                                 </li>
//                                                 <li>
//                                                   <svg
//                                                     xmlns="http://www.w3.org/2000/svg"
//                                                     width="32"
//                                                     height="32"
//                                                     viewBox="0 0 32 32"
//                                                     fill="none"
//                                                   >
//                                                     <path
//                                                       fillRule="evenodd"
//                                                       clipRule="evenodd"
//                                                       d="M26.3625 10.785C26.3715 11.0182 26.3745 11.2513 26.3745 11.4845C26.3745 18.5541 21.4014 26.7155 12.3073 26.7155C9.51376 26.7155 6.91616 25.8252 4.72754 24.3095C5.11442 24.3519 5.50733 24.3838 5.90626 24.3838C8.2225 24.3838 10.3558 23.5251 12.0481 22.0836C9.88456 22.0518 8.05771 20.4937 7.42765 18.3739C7.73012 18.4375 8.04161 18.4694 8.36015 18.4694C8.80933 18.4694 9.24544 18.4059 9.66347 18.2787C7.39949 17.7911 5.69423 15.629 5.69423 13.0322C5.69423 13.0004 5.69423 12.9897 5.69423 12.9685C6.36147 13.3607 7.12516 13.6043 7.9361 13.6361C6.60765 12.6716 5.73441 11.0288 5.73441 9.17396C5.73441 8.19884 5.97759 7.27668 6.40566 6.48175C8.84349 9.72507 12.4882 11.8555 16.5971 12.0781C16.5127 11.6859 16.4695 11.2727 16.4695 10.8593C16.4695 7.90216 18.6832 5.50671 21.4145 5.50671C22.8364 5.50671 24.1206 6.15335 25.022 7.19206C26.1504 6.95888 27.2076 6.51375 28.1642 5.899C27.7934 7.1497 27.0106 8.19879 25.9877 8.85594C26.9885 8.72875 27.9432 8.44279 28.8285 8.01883C28.1642 9.08933 27.3282 10.0325 26.3625 10.785Z"
//                                                       fill="#1EA1F2"
//                                                     />
//                                                   </svg>
//                                                 </li>
//                                               </ul>
//                                             </td>
//                                           </tr>
//                                         </tbody>
//                                       </table>
//                                     </div>
//                                   </TabPane>
//                                 </TabContent>
//                               </TabContainer>
//                             </div>
//                           </Col>
//                         </Row>
//                       </Card.Body>
//                     </Card>
//                   </Tab.Pane>
//                 </Tab.Content>
//               </Col>
//             </Tab.Container>
//           </Row>
//         </Container>
//       </div>
//     </>
//   );
// };

// export default StoreDetailOLD;

// *****************************######################*******************
// import React from "react";
// import {
//   Row,
//   Col,
//   Container,
//   Nav,
//   Button,
//   Table,
//   Tab,
//   Form,
//   Image,
//   Dropdown,
// } from "react-bootstrap";
// import Card from "../../../components/Card";
// import { Link } from "react-router-dom";

// // images
// import user1 from "../../../assets/images/user/11.png";
// import user05 from "../../../assets/images/user/05.jpg";
// import user01 from "../../../assets/images/user/01.jpg";
// import user02 from "../../../assets/images/user/02.jpg";
// import user03 from "../../../assets/images/user/03.jpg";
// import user06 from "../../../assets/images/user/06.jpg";
// import user07 from "../../../assets/images/user/07.jpg";
// import user08 from "../../../assets/images/user/08.jpg";
// import user09 from "../../../assets/images/user/09.jpg";
// import user04 from "../../../assets/images/user/04.jpg";
// import icon8 from "../../../assets/images/icon/08.png";
// import icon9 from "../../../assets/images/icon/09.png";
// import icon10 from "../../../assets/images/icon/10.png";
// import icon11 from "../../../assets/images/icon/11.png";
// import icon12 from "../../../assets/images/icon/12.png";
// import icon13 from "../../../assets/images/icon/13.png";
// import img1 from "../../../assets/images/page-img/profile-bg1.jpg";
// import ProfileHeader from "../../../components/profile-header";
// import profilebg8 from "../../../assets/images/page-img/profile-bg8.jpg";
// import profilebg9 from "../../../assets/images/page-img/profile-bg9.jpg";
// import robot from "../../../assets/images/page-img/robotimg.jpg";

// const StoreDetailOLD = () => {
//   return (
//     <>
//       <ProfileHeader img={profilebg9} />
//       <div id="content-page" className="content-inner">
//         <Container>
//           <Row>
//             <Col md={12} className="mb-4">
//               <div
//                 className="header-title"
//                 style={{ textAlign: "left", width: "100%" }}
//               >
//                 <h1 style={{ textAlign: "center", width: "100%" }}>
//                   Rewards & Recognition
//                 </h1>
//               </div>
//             </Col>
//             <Tab.Container id="left-tabs-example" defaultActiveKey="first">
//               <Col lg={12}>
//                 <Card>
//                   <Card.Body className="p-0">
//                     <div className="user-tabing p-3">
//                       <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
//                         <Nav
//                           variant="pills"
//                           className="d-flex align-items-center text-center profile-forum-items p-0 m-0 w-75"
//                         >
//                           <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="first"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 thumb_up
//                               </i>{" "}
//                               <span>Appreciate</span>
//                             </Nav.Link>
//                           </Col>
//                           <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="second"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 emoji_events
//                               </i>{" "}
//                               <span>Nominate</span>
//                             </Nav.Link>
//                           </Col>
//                           {/* <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="third"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 card_giftcard
//                               </i>{" "}
//                               <span>Greetings</span>
//                             </Nav.Link>
//                           </Col> */}
//                           <Col sm={3} className="p-0">
//                             <Nav.Link
//                               eventKey="fourth"
//                               role="button"
//                               className="d-flex gap-2 justify-content-center"
//                             >
//                               <i className="material-symbols-outlined me-1">
//                                 star
//                               </i>{" "}
//                               <span>My Earned Points</span>
//                             </Nav.Link>
//                           </Col>
//                         </Nav>
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//               <Col sm={12}>
//                 <Tab.Content className="forum-content">
//                   <Tab.Pane eventKey="first">
//                     <div id="post-modal-data" className="card">
//                       <div className="card-header d-flex justify-content-between border-bottom">
//                         <div className="header-title">
//                           <h5 className="card-title">Appreciate Here</h5>
//                         </div>
//                       </div>
//                       <div className="card-body">
//                         <div className="d-flex align-items-center mb-5">
//                           <form
//                             className="post-text w-100"
//                             // onClick={handleShow}
//                           >
//                             <input
//                               type="text"
//                               className="form-control rounded px-0"
//                               placeholder="Write And Appreciate Your Friends..."
//                               style={{ border: "none" }}
//                             />
//                           </form>
//                         </div>
//                       </div>
//                       <div className="card-body bg-primary-subtle rounded-bottom-3">
//                         <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
//                           <div className="create-post-data">
//                             <ul className="list-inline d-flex flex-wrap justify-content-center align-items-center gap-3 p-0 m-0">
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   thumb_up
//                                 </i>
//                                 <span>Great Job</span> |
//                               </li>
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   favorite
//                                 </i>{" "}
//                                 <span>Thank You</span>|
//                               </li>
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   bolt
//                                 </i>{" "}
//                                 <span>Responsive</span>|
//                               </li>
//                               <li className="d-flex gap-2 cursor-pointer">
//                                 <i className="icon material-symbols-outlined">
//                                   emoji_people
//                                 </i>{" "}
//                                 Respectful
//                               </li>
//                             </ul>
//                           </div>
//                           <div>
//                             <ul className="list-inline m-0 p-0 d-flex align-items-center gap-4">
//                               <li>
//                                 <Link to="#" className="text-body fw-medium">
//                                   Discard
//                                 </Link>
//                               </li>
//                               <li>
//                                 <button
//                                   type="button"
//                                   className="btn btn-primary px-4"
//                                 >
//                                   Post
//                                 </button>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </Tab.Pane>
//                   <Tab.Pane eventKey="second">
//                     <Card>
//                       <Card.Body className="p-4">
//                         <h4 className="text-center mb-4">Nomination Form</h4>

//                         <Form>
//                           <Form.Group className="mb-3" controlId="nomineeName">
//                             <Form.Label>Enter Name</Form.Label>
//                             <Form.Control
//                               type="text"
//                               placeholder="Enter name"
//                             />
//                           </Form.Group>

//                           <Form.Group
//                             className="mb-3"
//                             controlId="nominationReason"
//                           >
//                             <Form.Label>Write Your Message</Form.Label>
//                             <Form.Control
//                               as="textarea"
//                               rows={4}
//                               placeholder="Why do you nominate this person?"
//                             />
//                           </Form.Group>

//                           <Button
//                             variant="primary"
//                             type="submit"
//                             className="w-100"
//                           >
//                             Submit Nomination
//                           </Button>
//                         </Form>
//                       </Card.Body>
//                     </Card>
//                     <Card>
//                       <Card.Body>
//                         <div
//                           className="header-title"
//                           style={{ textAlign: "left", width: "100%" }}
//                         >
//                           <h1 style={{ textAlign: "center", width: "100%" }}>
//                             🏆 Your Recent Nominations
//                           </h1>
//                         </div>
//                         <Table
//                           responsive
//                           className="forum-table mb-0 rounded mt-4"
//                         >
//                           <thead className="bg-primary text-white">
//                             <tr>
//                               <th>Name</th>
//                               <th>Message</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             <tr>
//                               <td className="col-lg-6">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user07}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Bob Frapples</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       2 hours, 20 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-6">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Bob Frapples
//                                   </span>
//                                   20 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - Community Hangout
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-6">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user08}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Paul Moliver</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       2 hours, 18 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-6">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Paul Molive
//                                   </span>
//                                   18 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - Banking
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-6">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user01}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Bearded Wonder</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       3 hours, 22 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-6">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Pete Sariya
//                                   </span>
//                                   22 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - Comics
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-6">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user02}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Anna Mull</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       3 hours, 20 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-6">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Anna Mull
//                                   </span>
//                                   20 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - Community Hangout
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-4">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user03}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Terry Aki</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       3 hours, 18 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-4">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Terry Aki
//                                   </span>
//                                   18 minutes ago{" "}
//                                   <span className="text-primary">
//                                     - Community
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-4">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user04}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Alex john</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       2 hours, 16 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-4">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Alex john
//                                   </span>
//                                   16 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - expenses
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-4">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user05}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Rock lai</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       2 hours, 22 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-4">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Rock lai
//                                   </span>
//                                   22 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - Banking
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-4">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user06}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Ira Membrit</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       2 hours, 21 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-4">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Ira Membrit
//                                   </span>
//                                   21 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - expenses
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-4">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user09}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Greta Life</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       2 hours, 15 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-4">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Greta Life
//                                   </span>
//                                   15 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - Comics
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td className="col-lg-4">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     loading="lazy"
//                                     className="img-fluid rounded-circle avatar-40"
//                                     src={user05}
//                                     alt=""
//                                   />
//                                   <div className="media-body ms-3">
//                                     <h6 className="mb-0">
//                                       <Link to="#">Bearded Wonder</Link>
//                                     </h6>
//                                     <p className="mb-0">
//                                       3 hours, 22 minutes ago
//                                     </p>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="col-lg-4">
//                                 <h6>There are many variations of passages.</h6>
//                                 <p className="mb-0">
//                                   <span className="text-dark me-2">
//                                     Pete Sariya
//                                   </span>
//                                   22 minutes ago{" "}
//                                   <span className="text-primary">
//                                     {" "}
//                                     - Comics
//                                   </span>
//                                 </p>
//                               </td>
//                             </tr>
//                           </tbody>
//                         </Table>
//                       </Card.Body>
//                     </Card>
//                   </Tab.Pane>

//                   <Tab.Pane eventKey="third">
//                     <Card>
//                       <Card.Body className="p-4">
//                         <h4 className="text-primary text-center my-2">
//                           🎁 Send a Greeting to Your Friend!
//                         </h4>
//                         <Form>
//                           <Form.Group className="mb-3" controlId="friendName">
//                             <Form.Label>Friend's Name</Form.Label>
//                             <Form.Control
//                               type="text"
//                               placeholder="Enter your friend's name"
//                             />
//                           </Form.Group>

//                           <Form.Group
//                             className="mb-3"
//                             controlId="greetingMessage"
//                           >
//                             <Form.Label>Your Message</Form.Label>
//                             <Form.Control
//                               as="textarea"
//                               rows={3}
//                               placeholder="Write your heartfelt message here..."
//                             />
//                           </Form.Group>

//                           {/* <div className="d-flex justify-content-center gap-2 mb-3">
//                             <Button variant="outline-primary">😊</Button>
//                             <Button variant="outline-success">🎉</Button>
//                             <Button variant="outline-warning">❤️</Button>
//                           </div> */}

//                           <button
//                             type="button"
//                             className="btn btn-primary px-4"
//                           >
//                             Send Greeting
//                           </button>
//                         </Form>

//                         {/* Recent Greetings Section */}
//                         <hr className="my-4" />
//                         <h5 className="text-center my-4">
//                           🗨️ Recent Greetings
//                         </h5>
//                         <div className="recent-greetings">
//                           {[
//                             {
//                               name: "John Doe",
//                               message: "Wishing you a fantastic day! 🎉",
//                             },
//                             {
//                               name: "Jane Smith",
//                               message: "Hope you’re doing great! ❤️",
//                             },
//                             {
//                               name: "Alex Brown",
//                               message: "You’re awesome! 😊",
//                             },
//                           ].map((greeting, index) => (
//                             <div
//                               key={index}
//                               className="mb-3 p-3 bg-light rounded shadow-sm"
//                             >
//                               <strong>{greeting.name}</strong>
//                               <p className="mb-0">{greeting.message}</p>
//                             </div>
//                           ))}
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Tab.Pane>

//                   <Tab.Pane eventKey="fourth">
//                     <Card className="shadow-lg border-0 rounded-4">
//                       <Card.Body className="d-flex flex-column justify-content-center align-items-center py-4">
//                         <h1 className="display-3 fw-bold customText_color">
//                           60%
//                         </h1>
//                         <p className="text-muted fs-5">Available Points</p>
//                         <i
//                           className="material-symbols-outlined text-warning"
//                           style={{ fontSize: "3rem" }}
//                         >
//                           stars
//                         </i>
//                       </Card.Body>
//                     </Card>
//                   </Tab.Pane>
//                 </Tab.Content>
//               </Col>
//             </Tab.Container>
//           </Row>
//         </Container>
//       </div>
//     </>
//   );
// };

// export default StoreDetailOLD;,
